import hexRgb from 'hex-rgb';
import { unflatten } from 'flat';

/* DO NOT CHANGE!*/
/* This file is automatically generated from @entur/tokens! Changes will be overwritten. */
var primitive = {
  "blue": {
    "_10": "#f6f6f9",
    "_100": "#292b6a",
    "_20": "#eaeaf1",
    "_30": "#d9dae8",
    "_40": "#bcbdd2",
    "_50": "#9ea0bd",
    "_60": "#8284ab",
    "_70": "#626493",
    "_80": "#54568c",
    "_90": "#393d79"
  },
  "canary": {
    "_10": "#fffbeb",
    "_100": "#483705",
    "_20": "#fff4cd",
    "_30": "#ffeeb3",
    "_40": "#ffe082",
    "_50": "#ffda6b",
    "_60": "#ffca28",
    "_70": "#e9b10c",
    "_80": "#b38909",
    "_90": "#775b09"
  },
  "coral": {
    "_10": "#ffe5e5",
    "_100": "#370606",
    "_20": "#ffcece",
    "_30": "#ff9494",
    "_40": "#ff5959",
    "_50": "#f73e3b",
    "_60": "#d31b1b",
    "_70": "#b31414",
    "_80": "#8a1414",
    "_90": "#5d0e0e"
  },
  "ebony": {
    "_10": "#e5e5e9",
    "_100": "#08091c",
    "_15": "#d8d9df",
    "_20": "#cccdd4",
    "_25": "#bfc0c8",
    "_30": "#b3b4bd",
    "_35": "#a6a7b2",
    "_40": "#999aa7",
    "_45": "#8d8e9c",
    "_5": "#f2f2f5",
    "_50": "#81828f",
    "_55": "#757584",
    "_60": "#6a6b78",
    "_65": "#5e5f6c",
    "_70": "#525360",
    "_75": "#464755",
    "_80": "#393a49",
    "_85": "#2d2e3e",
    "_90": "#212233",
    "_95": "#141527"
  },
  "grey": {
    "_10": "#f2f5f7",
    "_100": "#262729",
    "_110": "#101112",
    "_20": "#edf0f2",
    "_30": "#e3e6e8",
    "_40": "#cfd2d4",
    "_50": "#b6b8ba",
    "_60": "#949699",
    "_70": "#6e6f73",
    "_80": "#515254",
    "_90": "#3d3e40"
  },
  "lavender": {
    "_10": "#f0f1fa",
    "_100": "#11143c",
    "_20": "#d9ddf2",
    "_30": "#c7cdeb",
    "_40": "#aeb7e2",
    "_50": "#8794d4",
    "_60": "#5a68c4",
    "_70": "#3b46ab",
    "_80": "#262f7d",
    "_90": "#181c56"
  },
  "mint": {
    "_10": "#e6f6f0",
    "_100": "#022015",
    "_20": "#d0f1e3",
    "_30": "#9cd9c2",
    "_40": "#5ac39a",
    "_50": "#37ab83",
    "_60": "#1a8e60",
    "_70": "#068152",
    "_80": "#05613e",
    "_90": "#034029"
  },
  "peach": {
    "_10": "#fff1eb",
    "_100": "#3a1503",
    "_20": "#ffe4d6",
    "_30": "#ffd3bd",
    "_40": "#ffbf9e",
    "_50": "#fd9a68",
    "_60": "#fd7835",
    "_70": "#e6560f",
    "_80": "#ae4009",
    "_90": "#742b06"
  },
  "sky": {
    "_10": "#e1eff8",
    "_100": "#011a23",
    "_20": "#acd7f1",
    "_30": "#64b3e7",
    "_40": "#2d98d2",
    "_50": "#067eb2",
    "_60": "#046690",
    "_70": "#044d6c",
    "_80": "#003852",
    "_90": "#022536"
  },
  "transparent": {
    "blueAlpha10": "#9ea0bd1a",
    "blueAlpha40": "#54568c66",
    "canaryAlpha25": "#ffe08240",
    "canaryAlpha30": "#fff4cd4d",
    "coralAlpha20": "#ff949433",
    "ebonyAlpha15": "#e5e5e926",
    "ebonyAlpha20": "#cccdd44d",
    "ebonyAlpha25": "#e5e5e940",
    "ebonyAlpha35": "#e5e5e959",
    "lavenderAlpha70": "#aeb7e2b2",
    "mintAlpha20": "#5ac39a33",
    "neutralAlpha10": "#cfd2d41a",
    "neutralAlpha15": "#cfd2d426",
    "neutralAlpha20": "#26272933",
    "peachAlpha70": "#ffbf9eb2",
    "skyAlpha20": "#2d98d233"
  },
  "white": {
    "alpha0": "#ffffff00",
    "alpha10": "#ffffff1a",
    "alpha100": "#ffffff",
    "alpha20": "#ffffff33",
    "alpha30": "#ffffff4d",
    "alpha40": "#ffffff66",
    "alpha50": "#ffffff80",
    "alpha60": "#ffffff99",
    "alpha70": "#ffffffb2",
    "alpha80": "#ffffffcc",
    "alpha90": "#ffffffe5"
  }
};

/* DO NOT CHANGE!*/
/* This file is automatically generated from @entur/tokens! Changes will be overwritten. */
var semantic = {
  "fill": {
    "background": {
      "contrast": {
        "dark": "#212233",
        "light": "#181c56",
        "lightalt": "#393d79",
        "lightalt2": "#292b6a"
      },
      "overlay": {
        "solid": "#393a49",
        "solidalt": "#464755",
        "transparent": "#e5e5e926",
        "transparentalt": "#e5e5e940",
        "transparentalt2": "#cccdd44d"
      },
      "standard": {
        "colorless": "#ffffff00",
        "dark": "#08091c",
        "light": "#ffffff"
      },
      "subdued": {
        "dark": "#2d2e3e",
        "light": "#d9dae8"
      },
      "tint": {
        "dark": "#141527",
        "light": "#f6f6f9",
        "neutral": "#f2f5f7",
        "transparent": "#9ea0bd1a"
      }
    },
    "boolean": {
      "false": {
        "contrast": "#9ea0bd",
        "dark": "#e5e5e959",
        "light": "#949699"
      },
      "true": {
        "contrast": "#5ac39a",
        "dark": "#5ac39a",
        "light": "#1a8e60"
      }
    },
    "disabled": {
      "light": "#cfd2d4",
      "transparent": "#cfd2d426",
      "transparentalt": "#cfd2d41a"
    },
    "information": {
      "contrast": "#64b3e7",
      "deep": "#067eb2",
      "muted": "#e1eff8",
      "tint": "#acd7f1",
      "transparent": "#2d98d233"
    },
    "negative": {
      "contrast": "#ff5959",
      "dark": "#5d0e0e",
      "deep": "#d31b1b",
      "muted": "#ffcece",
      "tint": "#ff9494",
      "transparent": "#ff949433"
    },
    "primary": {
      "active": {
        "contrast": "#8794d4",
        "light": "#11143c"
      },
      "default": {
        "contrast": "#aeb7e2",
        "light": "#181c56"
      },
      "hover": {
        "contrast": "#c7cdeb",
        "light": "#393d79"
      }
    },
    "secondary": {
      "active": {
        "contrast": "#8794d4",
        "light": "#aeb7e2"
      },
      "default": {
        "colorless": "#ffffff00"
      },
      "hover": {
        "contrast": "#626493",
        "light": "#d9ddf2"
      }
    },
    "selected": {
      "default": {
        "contrast": "#393d79",
        "dark": "#e5e5e9",
        "darkalt": "#81828f",
        "light": "#f6f6f9",
        "neutral": "#e3e6e8"
      },
      "hover": {
        "contrast": "#54568c",
        "dark": "#e5e5e959",
        "light": "#eaeaf1",
        "neutral": "#edf0f2"
      }
    },
    "success": {
      "contrast": "#5ac39a",
      "deep": "#1a8e60",
      "muted": "#d0f1e3",
      "subdued": "#37ab83",
      "tint": "#9cd9c2",
      "transparent": "#5ac39a33"
    },
    "warning": {
      "contrast": "#ffe082",
      "deep": "#ffca28",
      "muted": "#fff4cd",
      "tint": "#ffeeb3",
      "transparent": "#ffe08240"
    }
  },
  "shape": {
    "accent": "#181c56",
    "contrast": "#aeb7e2",
    "dark": "#08091c",
    "darkalt": "#b3b4bd",
    "disabled": "#515254",
    "highlight": "#ff5959",
    "highlightalt": "#ff9494",
    "inactive": "#bcbdd2",
    "information": "#067eb2",
    "informationalt": "#64b3e7",
    "informationalt2": "#acd7f1",
    "light": "#ffffff",
    "lightalt": "#e5e5e9",
    "negative": "#d31b1b",
    "negativealt": "#ff9494",
    "neutral": "#6e6f73",
    "neutralalt": "#b6b8ba",
    "neutralalt2": "#949699",
    "subdued": "#626493",
    "subduedalt": "#d9dae8",
    "success": "#1a8e60",
    "successalt": "#5ac39a",
    "successalt2": "#9cd9c2",
    "warning": "#ffca28",
    "warningalt": "#ffe082",
    "warningalt2": "#ffeeb3"
  },
  "stroke": {
    "accent": "#181c56",
    "colorless": "#ffffff00",
    "contrast": "#aeb7e2",
    "contrastalt": "#54568c",
    "dark": "#b3b4bd",
    "darkalt": "#81828f",
    "darkalt2": "#08091c",
    "highlight": "#ff5959",
    "highlightalt": "#ff9494",
    "information": "#067eb2",
    "informationalt": "#acd7f1",
    "light": "#ffffff",
    "lightalt": "#e5e5e9",
    "negative": "#d31b1b",
    "negativealt": "#ff9494",
    "neutral": "#e3e6e8",
    "neutralalt": "#949699",
    "subdued": "#8284ab",
    "success": "#1a8e60",
    "successalt": "#5ac39a",
    "successalt2": "#9cd9c2",
    "transparent": "#54568c66",
    "transparentalt": "#aeb7e2b2",
    "warning": "#e9b10c",
    "warningalt": "#ffeeb3"
  },
  "text": {
    "accent": "#181c56",
    "dark": "#08091c",
    "darkalt": "#b3b4bd",
    "disabled": "#515254",
    "highlight": "#aeb7e2",
    "highlightalt": "#ffbf9e",
    "light": "#ffffff",
    "lightalt": "#e5e5e9",
    "negative": "#d31b1b",
    "negativealt": "#ff9494",
    "neutral": "#6e6f73",
    "neutralalt": "#b6b8ba",
    "neutralalt2": "#949699",
    "subdued": "#626493",
    "subduedalt": "#d9dae8",
    "success": "#1a8e60",
    "successalt": "#5ac39a"
  }
};

/* DO NOT CHANGE!*/
/* This file is automatically generated from @entur/tokens! Changes will be overwritten. */
var base = {
  "light": {
    "baseColors": {
      "frame": {
        "contrast": "#181c56",
        "contrastalt": "#393d79",
        "contrastalt2": "#292b6a",
        "default": "#ffffff",
        "elevated": "#ffffff",
        "elevatedalt": "#f6f6f9",
        "subdued": "#d9dae8",
        "tint": "#f6f6f9"
      },
      "shape": {
        "accent": "#181c56",
        "bicycleContrast": "#00db9b",
        "bicycleDefault": "#388f76",
        "busContrast": "#ff6392",
        "busDefault": "#c5044e",
        "cablewayContrast": "#b482fb",
        "cablewayDefault": "#78469a",
        "disabled": "#6e6f73",
        "disabledalt": "#b6b8ba",
        "ferryContrast": "#6fdfff",
        "ferryDefault": "#0c6693",
        "funicularContrast": "#b482fb",
        "funicularDefault": "#78469a",
        "helicopterContrast": "#fbafea",
        "helicopterDefault": "#800664",
        "highlight": "#ff5959",
        "light": "#ffffff",
        "mask": "#ffffff",
        "maskalt": "#ffffff",
        "metroContrast": "#f08901",
        "metroDefault": "#bf5826",
        "mobilityContrast": "#00db9b",
        "mobilityDefault": "#388f76",
        "planeContrast": "#fbafea",
        "planeDefault": "#800664",
        "subdued": "#626493",
        "subduedalt": "#d9dae8",
        "taxiContrast": "#ffe082",
        "taxiDefault": "#3d3e40",
        "trainContrast": "#42a5f5",
        "trainDefault": "#00367f",
        "tramContrast": "#b482fb",
        "tramDefault": "#78469a",
        "walkContrast": "#8284ab",
        "walkDefault": "#8d8e9c",
        "airportlinkbusContrast": "#fbafea",
        "airportlinkbusDefault": "#800664",
        "airportlinkrailContrast": "#fbafea",
        "airportlinkrailDefault": "#800664"
      },
      "stroke": {
        "contrast": "#aeb7e2",
        "default": "#181c56",
        "disabled": "#949699",
        "focusContrast": "#aeb7e2",
        "focusStandard": "#181c56",
        "highlight": "#ff5959",
        "light": "#ffffff",
        "subdued": "#8284ab",
        "subduedalt": "#e3e6e8"
      },
      "text": {
        "accent": "#181c56",
        "disabled": "#6e6f73",
        "disabledalt": "#b6b8ba",
        "highlight": "#ff5959",
        "light": "#ffffff",
        "subdued": "#626493",
        "subduedalt": "#d9dae8"
      }
    }
  },
  "dark": {
    "baseColors": {
      "frame": {
        "contrast": "#212233",
        "contrastalt": "#141527",
        "contrastalt2": "#08091c",
        "default": "#08091c",
        "elevated": "#e5e5e926",
        "elevatedalt": "#464755",
        "subdued": "#2d2e3e",
        "tint": "#141527"
      },
      "shape": {
        "accent": "#e5e5e9",
        "bicycleContrast": "#4db295",
        "bicycleDefault": "#4db295",
        "busContrast": "#ef7398",
        "busDefault": "#ef7398",
        "cablewayContrast": "#b898e5",
        "cablewayDefault": "#b898e5",
        "disabled": "#b6b8ba",
        "disabledalt": "#b3b4bd",
        "ferryContrast": "#8ccfe2",
        "ferryDefault": "#8ccfe2",
        "funicularContrast": "#b898e5",
        "funicularDefault": "#b898e5",
        "helicopterContrast": "#f2b8e5",
        "helicopterDefault": "#f2b8e5",
        "highlight": "#ff9494",
        "light": "#e5e5e9",
        "mask": "#2d2e3e",
        "maskalt": "#393a49",
        "metroContrast": "#dd973c",
        "metroDefault": "#dd973c",
        "mobilityContrast": "#4db295",
        "mobilityDefault": "#4db295",
        "planeContrast": "#f2b8e5",
        "planeDefault": "#f2b8e5",
        "subdued": "#b3b4bd",
        "subduedalt": "#b3b4bd",
        "taxiContrast": "#ffe082",
        "taxiDefault": "#ffe082",
        "trainContrast": "#60a2d7",
        "trainDefault": "#60a2d7",
        "tramContrast": "#b898e5",
        "tramDefault": "#b898e5",
        "walkContrast": "#8d8e9c",
        "walkDefault": "#8d8e9c",
        "airportlinkbusContrast": "#f2b8e5",
        "airportlinkbusDefault": "#f2b8e5",
        "airportlinkrailContrast": "#f2b8e5",
        "airportlinkrailDefault": "#f2b8e5"
      },
      "stroke": {
        "contrast": "#aeb7e2",
        "default": "#b3b4bd",
        "disabled": "#e3e6e8",
        "focusContrast": "#aeb7e2",
        "focusStandard": "#aeb7e2",
        "highlight": "#ff9494",
        "light": "#b3b4bd",
        "subdued": "#81828f",
        "subduedalt": "#949699"
      },
      "text": {
        "accent": "#e5e5e9",
        "disabled": "#b6b8ba",
        "disabledalt": "#b6b8ba",
        "highlight": "#ff9494",
        "light": "#e5e5e9",
        "subdued": "#b3b4bd",
        "subduedalt": "#b3b4bd"
      }
    }
  }
};

/* DO NOT CHANGE!*/
/* This file is automatically generated from @entur/tokens! Changes will be overwritten. */
var data = {
  "light": {
    "contrast": {
      "azure": "#64b2fb",
      "blue": "#6c6eb7",
      "coral": "#ff5959",
      "jungle": "#0fc2b3",
      "lavender": "#aeb7e2",
      "lilac": "#ea8bea",
      "peach": "#ffbf9e",
      "spring": "#7bc00b"
    },
    "standard": {
      "azure": "#2f98fa",
      "blue": "#181c56",
      "coral": "#ff5959",
      "jungle": "#0ea2a8",
      "lavender": "#8692ca",
      "lilac": "#8e57e3",
      "peach": "#ca825b",
      "spring": "#57a257"
    }
  },
  "dark": {
    "contrast": {
      "azure": "#669bcc",
      "blue": "#aeb7e2",
      "coral": "#ff9494",
      "jungle": "#349d94",
      "lavender": "#7c8ad0",
      "lilac": "#c982c9",
      "peach": "#d6855c",
      "spring": "#8cb24c"
    },
    "standard": {
      "azure": "#669bcc",
      "blue": "#aeb7e2",
      "coral": "#ff9494",
      "jungle": "#349d94",
      "lavender": "#7c8ad0",
      "lilac": "#c982c9",
      "peach": "#d6855c",
      "spring": "#8cb24c"
    }
  }
};

/* DO NOT CHANGE!*/
/* This file is automatically generated from @entur/tokens! Changes will be overwritten. */
var transport = {
  "contrast": {
    "bicycle": "#00db9b",
    "bus": "#ff6392",
    "busTransparent": "#ff639226",
    "cableway": "#b482fb",
    "cablewayTransparent": "#b482fb26",
    "carferry": "#6fdfff",
    "carferryTransparent": "#6fdfff26",
    "citybike": "#00db9b",
    "ferry": "#6fdfff",
    "ferryTransparent": "#6fdfff26",
    "funicular": "#b482fb",
    "funicularTransparent": "#b482fb26",
    "helicopter": "#fbafea",
    "helicopterTransparent": "#fbafea26",
    "metro": "#f08901",
    "metroTransparent": "#f0890126",
    "mobility": "#00db9b",
    "neutral": "#ffffff",
    "plane": "#fbafea",
    "planeTransparent": "#fbafea26",
    "taxi": "#ffe082",
    "taxiTransparent": "#ffe08226",
    "train": "#42a5f5",
    "trainTransparent": "#42a5f526",
    "tram": "#b482fb",
    "tramTransparent": "#b482fb26",
    "walk": "#8284ab",
    "airportlinkbus": "#fbafea",
    "airportlinkbusTransparent": "#fbafea26",
    "airportlinkrail": "#fbafea",
    "airportlinkrailTransparent": "#fbafea26"
  },
  "dark": {
    "bicycle": "#4db295",
    "bus": "#ef7398",
    "busTransparent": "#ef739826",
    "cableway": "#b898e5",
    "cablewayTransparent": "#b898e526",
    "carferry": "#8ccfe2",
    "carferryTransparent": "#8ccfe226",
    "citybike": "#4db295",
    "ferry": "#8ccfe2",
    "ferryTransparent": "#8ccfe226",
    "funicular": "#b898e5",
    "funicularTransparent": "#b898e526",
    "helicopter": "#f2b8e5",
    "helicopterTransparent": "#f2b8e526",
    "metro": "#dd973c",
    "metroTransparent": "#dd973c26",
    "mobility": "#4db295",
    "neutral": "#e5e5e9",
    "plane": "#f2b8e5",
    "planeTransparent": "#f2b8e526",
    "taxi": "#ffe082",
    "taxiTransparent": "#ffe08226",
    "train": "#60a2d7",
    "trainTransparent": "#60a2d726",
    "tram": "#b898e5",
    "tramTransparent": "#b898e526",
    "walk": "#8d8e9c",
    "airportlinkbus": "#f2b8e5",
    "airportlinkbusTransparent": "#f2b8e526",
    "airportlinkrail": "#f2b8e5",
    "airportlinkrailTransparent": "#f2b8e526"
  },
  "standard": {
    "bicycle": "#388f76",
    "bus": "#c5044e",
    "busTransparent": "#c5044e26",
    "cableway": "#78469a",
    "cablewayTransparent": "#78469a26",
    "carferry": "#0c6693",
    "carferryTransparent": "#0c669326",
    "citybike": "#388f76",
    "ferry": "#0c6693",
    "ferryTransparent": "#0c669326",
    "funicular": "#78469a",
    "funicularTransparent": "#78469a26",
    "helicopter": "#800664",
    "helicopterTransparent": "#80066426",
    "metro": "#bf5826",
    "metroTransparent": "#bf582626",
    "mobility": "#388f76",
    "neutral": "#181c56",
    "plane": "#800664",
    "planeTransparent": "#80066426",
    "taxi": "#3d3e40",
    "taxiTransparent": "#3d3e4026",
    "train": "#00367f",
    "trainTransparent": "#00367f26",
    "tram": "#78469a",
    "tramTransparent": "#78469a26",
    "walk": "#8d8e9c",
    "airportlinkbus": "#800664",
    "airportlinkbusTransparent": "#80066426",
    "airportlinkrail": "#800664",
    "airportlinkrailTransparent": "#80066426"
  }
};

/* DO NOT CHANGE!*/
/* This file is automatically generated from @entur/tokens! Changes will be overwritten. */
var componentColors = {
  "light": {
    "components": {
      "layout": {
        "badge": {
          "information": {
            "contrast": {
              "border": "#ffffff00",
              "bullet": "#64b3e7",
              "fill": "#64b3e7",
              "text": "#181c56",
              "textBullet": "#ffffff"
            },
            "standard": {
              "border": "#067eb2",
              "bullet": "#067eb2",
              "fill": "#e1eff8",
              "text": "#181c56",
              "textBullet": "#181c56"
            }
          },
          "negative": {
            "contrast": {
              "border": "#ffffff00",
              "bullet": "#ff5959",
              "fill": "#ff9494",
              "text": "#181c56",
              "textBullet": "#ffffff"
            },
            "standard": {
              "border": "#d31b1b",
              "bullet": "#d31b1b",
              "fill": "#ffcece",
              "text": "#181c56",
              "textBullet": "#181c56"
            }
          },
          "neutral": {
            "contrast": {
              "border": "#ffffff00",
              "bullet": "#c7cdeb",
              "fill": "#54568c",
              "text": "#ffffff",
              "textBullet": "#ffffff"
            },
            "standard": {
              "border": "#949699",
              "bullet": "#81828f",
              "fill": "#f6f6f9",
              "text": "#181c56",
              "textBullet": "#181c56"
            }
          },
          "primary": {
            "contrast": {
              "bullet": "#aeb7e2",
              "fill": "#aeb7e2",
              "text": "#181c56",
              "textBullet": "#ffffff"
            },
            "standard": {
              "bullet": "#181c56",
              "fill": "#181c56",
              "text": "#ffffff",
              "textBullet": "#181c56"
            }
          },
          "success": {
            "contrast": {
              "border": "#ffffff00",
              "bullet": "#5ac39a",
              "fill": "#5ac39a",
              "text": "#181c56",
              "textBullet": "#ffffff"
            },
            "standard": {
              "border": "#1a8e60",
              "bullet": "#1a8e60",
              "fill": "#d0f1e3",
              "text": "#181c56",
              "textBullet": "#181c56"
            }
          },
          "warning": {
            "contrast": {
              "border": "#ffffff00",
              "bullet": "#ffe082",
              "fill": "#ffe082",
              "text": "#181c56",
              "textBullet": "#ffffff"
            },
            "standard": {
              "border": "#e9b10c",
              "bullet": "#ffca28",
              "fill": "#fff4cd",
              "text": "#181c56",
              "textBullet": "#181c56"
            }
          }
        },
        "card": {
          "contrast": {
            "borderDefault": "#ffffff00",
            "borderActive": "#aeb7e2",
            "divide": "#ff5959",
            "fillDefaultSolid": "#393d79",
            "fillDefaultTransparent": "#393d79",
            "fillHoveractive": "#54568c",
            "icon": "#ffffff",
            "shadowLayer1": "#ffffff00",
            "shadowLayer2": "#ffffff00",
            "shadowLayer3": "#ffffff00",
            "subjectText": "#d9dae8",
            "text": "#ffffff"
          },
          "standard": {
            "borderDefault": "#e3e6e8",
            "borderActive": "#181c56",
            "divide": "#ff5959",
            "fillDefaultSolid": "#ffffff",
            "fillDefaultTransparent": "#ffffff",
            "fillHoveractive": "#f6f6f9",
            "icon": "#181c56",
            "shadowLayer1": "#cccdd44d",
            "shadowLayer2": "#e5e5e959",
            "shadowLayer3": "#e5e5e926",
            "subjectText": "#626493",
            "text": "#181c56"
          }
        }
      },
      "alert": {
        "alertbox": {
          "information": {
            "contrast": {
              "border": "#067eb2",
              "fillDefault": "#acd7f1",
              "fillToast": "#acd7f1",
              "iconDefault": "#181c56",
              "iconToast": "#181c56",
              "textDefault": "#181c56",
              "textToast": "#181c56"
            },
            "standard": {
              "border": "#067eb2",
              "fillDefault": "#e1eff8",
              "fillToast": "#e1eff8",
              "iconDefault": "#067eb2",
              "iconToast": "#067eb2",
              "textDefault": "#181c56",
              "textToast": "#181c56"
            }
          },
          "negative": {
            "contrast": {
              "border": "#d31b1b",
              "fillDefault": "#ff9494",
              "fillToast": "#ff9494",
              "iconDefault": "#181c56",
              "iconToast": "#181c56",
              "textDefault": "#181c56",
              "textToast": "#181c56"
            },
            "standard": {
              "border": "#d31b1b",
              "fillDefault": "#ffcece",
              "fillToast": "#ffcece",
              "iconDefault": "#d31b1b",
              "iconToast": "#d31b1b",
              "textDefault": "#181c56",
              "textToast": "#181c56"
            }
          },
          "success": {
            "contrast": {
              "border": "#1a8e60",
              "fillDefault": "#9cd9c2",
              "fillToast": "#9cd9c2",
              "iconDefault": "#181c56",
              "iconToast": "#181c56",
              "textDefault": "#181c56",
              "textToast": "#181c56"
            },
            "standard": {
              "border": "#1a8e60",
              "fillDefault": "#d0f1e3",
              "fillToast": "#d0f1e3",
              "iconDefault": "#1a8e60",
              "iconToast": "#1a8e60",
              "textDefault": "#181c56",
              "textToast": "#181c56"
            }
          },
          "warning": {
            "contrast": {
              "border": "#e9b10c",
              "fillDefault": "#ffeeb3",
              "fillToast": "#ffeeb3",
              "iconDefault": "#181c56",
              "iconToast": "#181c56",
              "textDefault": "#181c56",
              "textDefault2": "#181c56"
            },
            "standard": {
              "border": "#e9b10c",
              "fillDefault": "#fff4cd",
              "fillToast": "#fff4cd",
              "iconDefault": "#181c56",
              "iconToast": "#181c56",
              "textDefault": "#181c56",
              "textToast": "#181c56"
            }
          }
        },
        "copyableText": {
          "contrast": {
            "border": "#ffffff00",
            "borderInteractive": "#aeb7e2",
            "fill": "#f6f6f9",
            "icon": "#181c56",
            "text": "#181c56"
          },
          "standard": {
            "border": "#54568c66",
            "borderInteractive": "#181c56",
            "fill": "#f6f6f9",
            "icon": "#181c56",
            "text": "#181c56"
          }
        }
      },
      "button": {
        "disabled": {
          "contrast": {
            "fill": "#cfd2d426",
            "iconDisabled": "#b6b8ba",
            "textDisabled": "#b6b8ba"
          },
          "standard": {
            "fill": "#cfd2d4",
            "iconDisabled": "#515254",
            "textDisabled": "#515254"
          }
        },
        "floating": {
          "contrast": {
            "active": "#d9dae8",
            "default": "#ffffff",
            "hover": "#f6f6f9",
            "icon": "#181c56",
            "text": "#181c56"
          },
          "standard": {
            "active": "#11143c",
            "default": "#181c56",
            "hover": "#393d79",
            "icon": "#ffffff",
            "text": "#ffffff"
          }
        },
        "iconButton": {
          "contrast": {
            "active": "#8794d4",
            "default": "#ffffff00",
            "hover": "#626493",
            "icon": "#ffffff",
            "iconActive": "#181c56",
            "text": "#ffffff",
            "textActive": "#181c56"
          },
          "standard": {
            "active": "#aeb7e2",
            "default": "#ffffff00",
            "hover": "#d9ddf2",
            "icon": "#181c56",
            "iconActive": "#181c56",
            "text": "#181c56",
            "textActive": "#181c56"
          }
        },
        "negative": {
          "contrast": {
            "active": "#ff9494",
            "border": "#ff9494",
            "default": "#ffffff00",
            "hover": "#ff949433",
            "icon": "#ffffff",
            "iconActive": "#181c56",
            "text": "#ffffff",
            "textActive": "#181c56"
          },
          "standard": {
            "active": "#d31b1b",
            "border": "#d31b1b",
            "default": "#ffffff00",
            "hover": "#ffcece",
            "icon": "#d31b1b",
            "iconActive": "#ffffff",
            "text": "#d31b1b",
            "textActive": "#ffffff"
          }
        },
        "primary": {
          "contrast": {
            "active": "#8794d4",
            "default": "#aeb7e2",
            "hover": "#c7cdeb",
            "icon": "#181c56",
            "text": "#181c56"
          },
          "standard": {
            "active": "#11143c",
            "default": "#181c56",
            "hover": "#393d79",
            "icon": "#ffffff",
            "text": "#ffffff"
          }
        },
        "secondary": {
          "contrast": {
            "active": "#8794d4",
            "border": "#8284ab",
            "borderActive": "#ffffff00",
            "default": "#ffffff00",
            "hover": "#626493",
            "icon": "#ffffff",
            "iconActive": "#181c56",
            "text": "#ffffff",
            "textActive": "#181c56"
          },
          "standard": {
            "active": "#aeb7e2",
            "border": "#8284ab",
            "borderActive": "#181c56",
            "default": "#ffffff00",
            "hover": "#d9ddf2",
            "icon": "#181c56",
            "iconActive": "#181c56",
            "text": "#181c56",
            "textActive": "#181c56"
          }
        },
        "squareSecondary": {
          "contrast": {
            "active": "#8794d4",
            "border": "#8284ab",
            "borderActive": "#ffffff00",
            "default": "#ffffff00",
            "hover": "#d9ddf2",
            "iconActive": "#181c56",
            "iconDefault": "#ffffff",
            "iconHover": "#181c56",
            "label": "#ffffff"
          },
          "standard": {
            "active": "#aeb7e2",
            "border": "#8284ab",
            "borderActive": "#181c56",
            "default": "#ffffff00",
            "hover": "#d9ddf2",
            "icon": "#181c56",
            "iconActive": "#181c56",
            "text": "#181c56"
          }
        },
        "squareSuccess": {
          "contrast": {
            "active": "#37ab83",
            "border": "#ffffff00",
            "default": "#5ac39a",
            "hover": "#9cd9c2",
            "icon": "#181c56",
            "label": "#ffffff"
          },
          "standard": {
            "active": "#37ab83",
            "border": "#181c56",
            "default": "#5ac39a",
            "hover": "#9cd9c2",
            "icon": "#181c56",
            "label": "#181c56"
          }
        },
        "success": {
          "contrast": {
            "active": "#37ab83",
            "border": "#ffffff00",
            "default": "#5ac39a",
            "hover": "#9cd9c2",
            "icon": "#181c56",
            "text": "#181c56"
          },
          "standard": {
            "active": "#37ab83",
            "border": "#181c56",
            "default": "#5ac39a",
            "hover": "#9cd9c2",
            "icon": "#181c56",
            "text": "#181c56"
          }
        }
      },
      "chip": {
        "contrast": {
          "active": "#8794d4",
          "border": "#aeb7e2b2",
          "borderDisabled": "#949699",
          "default": "#ffffff00",
          "hover": "#626493",
          "iconDisabled": "#b6b8ba",
          "iconSelected": "#181c56",
          "iconUnselected": "#ffffff",
          "textDisabled": "#b6b8ba",
          "textSelected": "#181c56",
          "textUnselected": "#ffffff"
        },
        "standard": {
          "active": "#aeb7e2",
          "border": "#54568c66",
          "borderDisabled": "#949699",
          "default": "#ffffff00",
          "hover": "#d9ddf2",
          "iconDisabled": "#6e6f73",
          "iconSelected": "#181c56",
          "iconUnselected": "#181c56",
          "textDisabled": "#6e6f73",
          "textSelected": "#181c56",
          "textUnselected": "#181c56"
        }
      },
      "datepicker": {
        "calendar": {
          "background": "#ffffff",
          "border": "#e3e6e8",
          "dateborder": "#e3e6e8",
          "datefillHover": "#d9ddf2",
          "datefillSelected": "#aeb7e2",
          "icon": "#181c56",
          "strokeToday": "#ff5959",
          "textAccent": "#181c56",
          "textDisabled": "#b6b8ba",
          "textSubdued": "#626493"
        }
      },
      "expand": {
        "expandablePanel": {
          "contrast": {
            "fillDefault": "#393d79",
            "fillHover": "#626493",
            "fillSelected": "#393d79",
            "icon": "#ffffff",
            "text": "#ffffff"
          },
          "standard": {
            "fillDefault": "#e3e6e8",
            "fillHover": "#edf0f2",
            "fillSelected": "#e3e6e8",
            "icon": "#181c56",
            "text": "#181c56"
          }
        },
        "expandableText": {
          "contrast": {
            "icon": "#ffffff",
            "text": "#ffffff"
          },
          "standard": {
            "icon": "#181c56",
            "text": "#181c56"
          }
        }
      },
      "form": {
        "baseForm": {
          "contrast": {
            "borderDefault": "#8284ab",
            "borderInteractive": "#aeb7e2",
            "borderNegative": "#ff9494",
            "borderSuccess": "#5ac39a",
            "fillDefault": "#ffffff",
            "fillDisabled": "#cfd2d426",
            "fillReadonly": "#ffffff00",
            "icon": "#181c56",
            "iconDisabled": "#6e6f73",
            "textContent": "#181c56",
            "textDescription": "#ffffff",
            "textLabel": "#626493",
            "textDisabled": "#6e6f73"
          },
          "standard": {
            "borderDefault": "#8284ab",
            "borderInteractive": "#181c56",
            "borderNegative": "#d31b1b",
            "borderSuccess": "#1a8e60",
            "fillDefault": "#ffffff",
            "fillDisabled": "#cfd2d4",
            "fillReadonly": "#ffffff00",
            "icon": "#181c56",
            "iconDisabled": "#6e6f73",
            "textContent": "#181c56",
            "textDescription": "#181c56",
            "textLabel": "#626493",
            "textDisabled": "#6e6f73"
          }
        },
        "baseMenu": {
          "border": "#8284ab",
          "fillDefault": "#f2f5f7",
          "fillHover": "#d9ddf2",
          "fillSelected": "#aeb7e2",
          "icon": "#181c56",
          "iconDisabled": "#6e6f73",
          "text": "#181c56",
          "textDisabled": "#6e6f73"
        },
        "basePanel": {
          "contrast": {
            "borderDefault": "#8284ab",
            "borderDisabled": "#949699",
            "borderSelected": "#aeb7e2",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cfd2d426",
            "fillExpired": "#ff949433",
            "fillHover": "#54568c",
            "fillSelected": "#393d79",
            "textAccent": "#ffffff",
            "textDisabled": "#b6b8ba",
            "textRebate": "#5ac39a",
            "textSubdued": "#d9dae8"
          },
          "standard": {
            "borderDefault": "#8284ab",
            "borderDisabled": "#949699",
            "borderSelected": "#181c56",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cfd2d4",
            "fillExpired": "#ff949433",
            "fillHover": "#eaeaf1",
            "fillSelected": "#f6f6f9",
            "textAccent": "#181c56",
            "textDisabled": "#6e6f73",
            "textRebate": "#1a8e60",
            "textSubdued": "#626493"
          }
        },
        "checkbox": {
          "contrast": {
            "border": "#aeb7e2",
            "borderDisabled": "#6e6f73",
            "borderNegative": "#ff9494",
            "borderReadonly": "#6e6f73",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cfd2d426",
            "fillHover": "#626493",
            "fillSelected": "#aeb7e2",
            "fillSelectedhover": "#c7cdeb",
            "icon": "#181c56",
            "iconDisabled": "#949699",
            "iconReadonly": "#ffffff",
            "text": "#ffffff",
            "textDisabled": "#949699"
          },
          "standard": {
            "border": "#181c56",
            "borderDisabled": "#e3e6e8",
            "borderNegative": "#d31b1b",
            "borderReadonly": "#e3e6e8",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cfd2d426",
            "fillHover": "#d9ddf2",
            "fillSelected": "#181c56",
            "fillSelectedhover": "#393d79",
            "icon": "#ffffff",
            "iconDisabled": "#b6b8ba",
            "iconReadonly": "#181c56",
            "text": "#181c56",
            "textDisabled": "#b6b8ba"
          }
        },
        "feedbackText": {
          "information": {
            "contrast": {
              "iconFill": "#64b3e7",
              "iconSymbol": "#181c56",
              "stroke": "#181c56",
              "text": "#ffffff"
            },
            "standard": {
              "iconFill": "#067eb2",
              "iconSymbol": "#ffffff",
              "stroke": "#ffffff",
              "text": "#181c56"
            }
          },
          "negative": {
            "contrast": {
              "iconFill": "#ff9494",
              "iconSymbol": "#181c56",
              "stroke": "#181c56",
              "text": "#ffffff"
            },
            "standard": {
              "iconFill": "#d31b1b",
              "stroke": "#ffffff",
              "symbol": "#ffffff",
              "text": "#181c56"
            }
          },
          "success": {
            "contrast": {
              "iconFill": "#5ac39a",
              "iconStroke": "#181c56",
              "iconSymbol": "#181c56",
              "text": "#ffffff"
            },
            "standard": {
              "iconFill": "#1a8e60",
              "iconStroke": "#ffffff",
              "iconSymbol": "#ffffff",
              "text": "#181c56"
            }
          },
          "warning": {
            "contrast": {
              "icon": "#ffe082",
              "iconSymbol": "#181c56",
              "stroke": "#181c56",
              "text": "#ffffff"
            },
            "standard": {
              "iconFill": "#ffca28",
              "iconSymbol": "#181c56",
              "stroke": "#ffffff",
              "text": "#181c56"
            }
          }
        },
        "radio": {
          "contrast": {
            "border": "#aeb7e2",
            "borderDisabled": "#6e6f73",
            "borderNegative": "#ff9494",
            "borderReadonly": "#6e6f73",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cfd2d426",
            "fillHover": "#626493",
            "fillSelected": "#aeb7e2",
            "fillSelectedhover": "#c7cdeb",
            "icon": "#ffffff",
            "iconDisabled": "#949699",
            "iconReadonly": "#ffffff",
            "text": "#ffffff",
            "textDisabled": "#949699"
          },
          "standard": {
            "border": "#181c56",
            "borderDisabled": "#e3e6e8",
            "borderNegative": "#d31b1b",
            "borderReadonly": "#e3e6e8",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cfd2d426",
            "fillHover": "#d9ddf2",
            "fillSelected": "#181c56",
            "icon": "#181c56",
            "iconDisabled": "#b6b8ba",
            "iconReadonly": "#181c56",
            "selectedhover": "#393d79",
            "text": "#181c56",
            "textDisabled": "#b6b8ba"
          }
        },
        "segmentedControl": {
          "contrast": {
            "background": "#393d79",
            "fillHover": "#626493",
            "fillSelected": "#ffffff",
            "fillUnselected": "#ffffff00",
            "iconSelected": "#181c56",
            "iconUnselected": "#ffffff",
            "textSelected": "#181c56",
            "textUnselected": "#ffffff"
          },
          "standard": {
            "background": "#d9dae8",
            "fillHover": "#eaeaf1",
            "fillSelected": "#ffffff",
            "fillUnselected": "#ffffff00",
            "iconSelected": "#181c56",
            "iconUnselected": "#181c56",
            "textSelected": "#181c56",
            "textUnselected": "#181c56"
          }
        },
        "switch": {
          "contrast": {
            "fillFalse": "#9ea0bd",
            "fillTrue": "#5ac39a",
            "iconFalse": "#626493",
            "iconTrue": "#181c56",
            "switch": "#ffffff",
            "text": "#ffffff"
          },
          "standard": {
            "fillFalse": "#949699",
            "fillTrue": "#1a8e60",
            "iconFalse": "#6e6f73",
            "iconTrue": "#181c56",
            "switch": "#ffffff",
            "text": "#181c56"
          }
        }
      },
      "loader": {
        "fileupload": {
          "contrast": {
            "fillDefault": "#ffffff00",
            "icon": "#ffffff",
            "iconDisabled": "#949699",
            "strokeDefault": "#8284ab",
            "strokeDisabled": "#949699",
            "strokeNegative": "#ff9494",
            "strokeSuccess": "#5ac39a",
            "text": "#ffffff",
            "textDisabled": "#949699"
          },
          "standard": {
            "fillDefault": "#ffffff00",
            "icon": "#181c56",
            "iconDisabled": "#6e6f73",
            "strokeDefault": "#8284ab",
            "strokeDisabled": "#949699",
            "strokeNegative": "#d31b1b",
            "strokeSuccess": "#1a8e60",
            "text": "#181c56",
            "textDisabled": "#6e6f73"
          }
        },
        "loader": {
          "contrast": {
            "border": "#8284ab",
            "progressbar": "#ff5959",
            "text": "#ffffff"
          },
          "standard": {
            "border": "#949699",
            "progressbar": "#ff5959",
            "text": "#181c56"
          }
        },
        "spinner": {
          "contrast": {
            "fill": "#ffffff"
          },
          "standard": {
            "fill": "#181c56"
          }
        },
        "skeleton": {
          "contrast": {
            "fill": "#292b6a",
            "highlight": "#181c56"
          },
          "standard": {
            "fill": "#eaeaf1",
            "highlight": "#f6f6f9"
          }
        }
      },
      "menu": {
        "breadcrumb": {
          "contrast": {
            "icon": "#ffffff",
            "text": "#ffffff"
          },
          "standard": {
            "icon": "#181c56",
            "text": "#181c56"
          }
        },
        "navigationBar": {
          "contrast": {
            "background": "#393d79",
            "divide": "#ffffff00",
            "iconSelected": "#ffffff",
            "iconUnselected": "#d9dae8",
            "strokeSelected": "#ff5959",
            "textSelected": "#ffffff",
            "textUnselected": "#d9dae8"
          },
          "standard": {
            "background": "#ffffff",
            "divide": "#e3e6e8",
            "iconSelected": "#181c56",
            "iconUnselected": "#626493",
            "strokeSelected": "#ff5959",
            "textSelected": "#181c56",
            "textUnselected": "#626493"
          }
        },
        "navigationLink": {
          "contrast": {
            "icon": "#ffffff",
            "text": "#ffffff"
          },
          "standard": {
            "icon": "#181c56",
            "text": "#181c56"
          }
        },
        "overflowMenu": {
          "border": "#8284ab",
          "fillActive": "#aeb7e2",
          "fillDefault": "#f2f5f7",
          "fillHover": "#d9ddf2",
          "icon": "#181c56",
          "iconDisabled": "#6e6f73",
          "text": "#181c56",
          "textDisabled": "#6e6f73"
        },
        "pagination": {
          "contrast": {
            "active": "#8794d4",
            "borderSelected": "#ffffff",
            "borderUnselected": "#aeb7e2b2",
            "default": "#ffffff00",
            "hover": "#626493",
            "icon": "#ffffff",
            "textSelected": "#181c56",
            "textSubdued": "#d9dae8",
            "textUnselected": "#ffffff"
          },
          "standard": {
            "active": "#aeb7e2",
            "borderSelected": "#181c56",
            "borderUnselected": "#54568c66",
            "default": "#ffffff00",
            "hover": "#d9ddf2",
            "icon": "#181c56",
            "textSelected": "#181c56",
            "textSubdued": "#626493",
            "textUnselected": "#181c56"
          }
        },
        "sideNavigation": {
          "contrast": {
            "avatar": "#393d79",
            "background": "#181c56",
            "divide": "#8284ab",
            "fillActive": "#ffffff00",
            "fillDefault": "#ffffff00",
            "fillHover": "#393d79",
            "icon": "#ffffff",
            "iconDisabled": "#b6b8ba",
            "iconLabel": "#aeb7e2",
            "label": "#aeb7e2",
            "strokeSelected": "#ff5959",
            "text": "#ffffff",
            "textDisabled": "#b6b8ba"
          },
          "standard": {
            "avatar": "#ffffff",
            "background": "#f2f5f7",
            "divide": "#e3e6e8",
            "fillActive": "#ffffff00",
            "fillDefault": "#ffffff00",
            "fillHover": "#d9dae8",
            "icon": "#181c56",
            "iconDisabled": "#6e6f73",
            "iconLabel": "#626493",
            "label": "#626493",
            "strokeSelected": "#181c56",
            "text": "#181c56",
            "textDisabled": "#6e6f73"
          }
        },
        "stepper": {
          "contrast": {
            "background": "#626493",
            "progressbar": "#aeb7e2",
            "textCompleted": "#ffffff",
            "textUncompleted": "#aeb7e2"
          },
          "standard": {
            "background": "#e3e6e8",
            "progressbar": "#181c56",
            "textCompleted": "#181c56",
            "textUncompleted": "#6e6f73"
          }
        },
        "tableOfContent": {
          "contrast": {
            "iconSelected": "#ffffff",
            "iconUnselected": "#d9dae8",
            "strokeSelected": "#ff5959",
            "strokeUnselected": "#54568c",
            "textSelected": "#ffffff",
            "textUnselected": "#d9dae8"
          },
          "standard": {
            "iconSelected": "#181c56",
            "iconUnselected": "#626493",
            "strokeSelected": "#ff5959",
            "strokeUnselected": "#e3e6e8",
            "textSelected": "#181c56",
            "textUnselected": "#626493"
          }
        }
      },
      "modal": {
        "drawer": {
          "contrast": {
            "background": "#393d79",
            "text": "#ffffff"
          },
          "standard": {
            "background": "#eaeaf1",
            "text": "#181c56"
          }
        },
        "modal": {
          "contrast": {
            "border": "#ffffff00",
            "fill": "#ffffff",
            "icon": "#181c56",
            "text": "#181c56"
          },
          "standard": {
            "border": "#e3e6e8",
            "fill": "#ffffff",
            "icon": "#181c56",
            "text": "#181c56"
          }
        }
      },
      "tab": {
        "contrast": {
          "border": "#aeb7e2",
          "fillDisabled": "#54568c66",
          "fillHover": "#626493",
          "fillSelected": "#181c56",
          "fillUnselected": "#393d79",
          "icon": "#ffffff",
          "iconDisabled": "#b6b8ba",
          "text": "#ffffff",
          "textDisabled": "#b6b8ba",
          "underlineSelected": "#ff5959"
        },
        "standard": {
          "border": "#e3e6e8",
          "fillDisabled": "#cfd2d4",
          "fillHover": "#e3e6e8",
          "fillSelected": "#ffffff",
          "fillUnselected": "#edf0f2",
          "icon": "#181c56",
          "iconDisabled": "#515254",
          "text": "#181c56",
          "textDisabled": "#515254",
          "underlineSelected": "#ff5959"
        }
      },
      "table": {
        "contrast": {
          "cellFill": "#ffffff00",
          "cellFillHover": "#393d79",
          "cellFillNegative": "#ff949433",
          "headerFill": "#181c56",
          "icon": "#ffffff",
          "stroke": "#8284ab",
          "text": "#ffffff"
        },
        "standard": {
          "cellFill": "#ffffff00",
          "cellFillHover": "#f2f5f7",
          "fillNegative": "#ffcece",
          "headerFill": "#ffffff",
          "icon": "#181c56",
          "stroke": "#e3e6e8",
          "text": "#181c56"
        }
      },
      "tooltip": {
        "popover": {
          "contrast": {
            "border": "#ffffff00",
            "fill": "#393d79",
            "icon": "#ffffff",
            "text": "#ffffff"
          },
          "standard": {
            "border": "#54568c66",
            "fill": "#f6f6f9",
            "icon": "#181c56",
            "text": "#181c56"
          }
        },
        "tooltip": {
          "contrast": {
            "fill": "#ffffff",
            "fillNegative": "#ff9494",
            "icon": "#181c56",
            "iconNegative": "#181c56",
            "text": "#181c56",
            "textNegative": "#181c56",
            "triangle": "#ffffff",
            "triangleNegative": "#ff9494"
          },
          "standard": {
            "fill": "#181c56",
            "fillNegative": "#ffcece",
            "icon": "#ffffff",
            "iconNegative": "#181c56",
            "text": "#ffffff",
            "textNegative": "#181c56",
            "triangle": "#181c56",
            "triangleNegative": "#ffcece"
          }
        }
      },
      "travel": {
        "legLine": {
          "strokeLine": "#ff5959"
        },
        "seatmap": {
          "background": "#ffffff",
          "border": "#949699",
          "borderReverse": "#181c56",
          "fillChosen": "#54568c",
          "fillConfirm": "#d0f1e3",
          "fillConflict": "#fff4cd",
          "fillExit": "#5ac39a",
          "fillFree": "#eaeaf1",
          "fillHeadpillow": "#ffffff",
          "fillReverse": "#ffffff",
          "fillUnavailable": "#f2f5f7",
          "fillWc": "#e3e6e8",
          "fillWindow": "#e1eff8",
          "iconReverse": "#181c56",
          "iconWc": "#181c56",
          "strokeChosen": "#181c56",
          "strokeConfirm": "#1a8e60",
          "strokeConflict": "#e9b10c",
          "strokeFree": "#181c56",
          "strokeUnavailable": "#54568c66",
          "textChosen": "#ffffff",
          "textFree": "#181c56",
          "textUnavailable": "#181c56"
        },
        "travelHeader": {
          "contrast": {
            "strokeLine": "#ff5959",
            "text": "#ffffff"
          },
          "standard": {
            "strokeLine": "#ff5959",
            "text": "#181c56"
          }
        },
        "travelLeg": {
          "contrast": {
            "air": "#fbafea",
            "airportlinkbus": "#fbafea",
            "airportlinkrail": "#fbafea",
            "bicycle": "#00db9b",
            "bulletBorder": "#181c56",
            "bus": "#ff6392",
            "cableway": "#b482fb",
            "carferry": "#6fdfff",
            "citybike": "#00db9b",
            "ferry": "#6fdfff",
            "funicular": "#b482fb",
            "helicopter": "#fbafea",
            "metro": "#f08901",
            "mobility": "#00db9b",
            "plane": "#fbafea",
            "rail": "#42a5f5",
            "taxi": "#ffe082",
            "train": "#42a5f5",
            "tram": "#b482fb",
            "walk": "#8284ab",
            "water": "#6fdfff"
          },
          "standard": {
            "air": "#800664",
            "airportlinkbus": "#800664",
            "airportlinkrail": "#800664",
            "bicycle": "#388f76",
            "bulletBorder": "#ffffff",
            "bus": "#c5044e",
            "cableway": "#78469a",
            "carferry": "#0c6693",
            "citybike": "#388f76",
            "ferry": "#0c6693",
            "funicular": "#78469a",
            "helicopter": "#800664",
            "metro": "#bf5826",
            "mobility": "#388f76",
            "plane": "#800664",
            "rail": "#00367f",
            "taxi": "#3d3e40",
            "train": "#00367f",
            "tram": "#78469a",
            "walk": "#8d8e9c",
            "water": "#0c6693"
          }
        },
        "travelSwitch": {
          "contrast": {
            "backgroundfalse": "#626493",
            "backgroundtrueAir": "#fbafea",
            "backgroundtrueBicycle": "#00db9b",
            "backgroundtrueBus": "#ff6392",
            "backgroundtrueCableway": "#b482fb",
            "backgroundtrueCarferry": "#6fdfff",
            "backgroundtrueCitybike": "#00db9b",
            "backgroundtrueFerry": "#6fdfff",
            "backgroundtrueFunicular": "#b482fb",
            "backgroundtrueHelicopter": "#fbafea",
            "backgroundtrueMetro": "#f08901",
            "backgroundtrueMobility": "#00db9b",
            "backgroundtruePlane": "#fbafea",
            "backgroundtrueRail": "#42a5f5",
            "backgroundtrueTaxi": "#ffe082",
            "backgroundtrueTrain": "#42a5f5",
            "backgroundtrueTram": "#b482fb",
            "backgroundtrueWalk": "#8284ab",
            "backgroundtrueWater": "#6fdfff",
            "backgroundtrueAirportlinkbus": "#fbafea",
            "backgroundtrueAirportlinkrail": "#fbafea",
            "iconfalse": "#626493",
            "icontrueBicycle": "#388f76",
            "icontrueBus": "#c5044e",
            "icontrueCableway": "#78469a",
            "icontrueCarferry": "#0c6693",
            "icontrueCitybike": "#388f76",
            "icontrueFerry": "#0c6693",
            "icontrueFunicular": "#78469a",
            "icontrueHelicopter": "#800664",
            "icontrueMetro": "#bf5826",
            "icontrueMobility": "#388f76",
            "icontruePlane": "#800664",
            "icontrueTaxi": "#3d3e40",
            "icontrueTrain": "#00367f",
            "icontrueTram": "#78469a",
            "icontrueWalk": "#8284ab",
            "icontrueAirportlinkbus": "#800664",
            "icontrueAirportlinkrail": "#800664",
            "switchfillFalse": "#ffffff",
            "switchfillTrue": "#ffffff",
            "text": "#ffffff"
          },
          "standard": {
            "backgroundfalse": "#949699",
            "backgroundtrueAir": "#800664",
            "backgroundtrueBicycle": "#388f76",
            "backgroundtrueBus": "#c5044e",
            "backgroundtrueCableway": "#78469a",
            "backgroundtrueCarferry": "#0c6693",
            "backgroundtrueCitybike": "#388f76",
            "backgroundtrueFerry": "#0c6693",
            "backgroundtrueFunicular": "#78469a",
            "backgroundtrueHelicopter": "#800664",
            "backgroundtrueMetro": "#bf5826",
            "backgroundtrueMobility": "#388f76",
            "backgroundtruePlane": "#800664",
            "backgroundtrueRail": "#00367f",
            "backgroundtrueTaxi": "#3d3e40",
            "backgroundtrueTrain": "#00367f",
            "backgroundtrueTram": "#78469a",
            "backgroundtrueWalk": "#8d8e9c",
            "backgroundtrueWater": "#0c6693",
            "backgroundtrueAirportlinkbus": "#800664",
            "backgroundtrueAirportlinkrail": "#800664",
            "iconfalse": "#6e6f73",
            "icontrueBicycle": "#388f76",
            "icontrueBus": "#c5044e",
            "icontrueCableway": "#78469a",
            "icontrueCarferry": "#0c6693",
            "icontrueCitybike": "#388f76",
            "icontrueFerry": "#0c6693",
            "icontrueFunicular": "#78469a",
            "icontrueHelicopter": "#800664",
            "icontrueMetro": "#bf5826",
            "icontrueMobility": "#388f76",
            "icontruePlane": "#800664",
            "icontrueRail": "#00367f",
            "icontrueTaxi": "#3d3e40",
            "icontrueTrain": "#00367f",
            "icontrueTram": "#78469a",
            "icontrueWalk": "#8d8e9c",
            "icontrueWater": "#0c6693",
            "icontrueAirportlinkbus": "#800664",
            "icontrueAirportlinkbus2": "#800664",
            "icontrueAirportlinkrail": "#800664",
            "switchfillFalse": "#ffffff",
            "switchfillTrue": "#ffffff",
            "text": "#181c56"
          }
        },
        "travelTag": {
          "contrast": {
            "icon": "#181c56",
            "iconBusCancled": "#ff6392",
            "iconCabllewayCancled": "#b482fb",
            "iconCarferryCancled": "#6fdfff",
            "iconFerryCancled": "#6fdfff",
            "iconFunicularCancled": "#b482fb",
            "iconHelicopterCancled": "#fbafea",
            "iconMetroCancled": "#f08901",
            "iconPlaneCancled": "#fbafea",
            "iconTaxiCancled": "#ffe082",
            "iconTrainCancled": "#42a5f5",
            "iconTramCancled": "#b482fb",
            "iconWalk": "#181c56",
            "iconAirportlinkbusCancled": "#fbafea",
            "iconAirportlinkrailCancled": "#fbafea",
            "iconborderValidation": "#181c56",
            "tagfillAir": "#fbafea",
            "tagfillBicycle": "#00db9b",
            "tagfillBus": "#ff6392",
            "tagfillBusCancled": "#c5044e26",
            "tagfillCableway": "#b482fb",
            "tagfillCablewayCancled": "#b482fb26",
            "tagfillCarferry": "#6fdfff",
            "tagfillCarferryCancled": "#6fdfff26",
            "tagfillCitybike": "#00db9b",
            "tagfillFerry": "#6fdfff",
            "tagfillFerryCancled": "#6fdfff26",
            "tagfillFunicular": "#b482fb",
            "tagfillFunicularCancled": "#b482fb26",
            "tagfillHelicopter": "#fbafea",
            "tagfillHelicopterCancled": "#fbafea26",
            "tagfillMetro": "#f08901",
            "tagfillMetroCancled": "#f0890126",
            "tagfillMobility": "#00db9b",
            "tagfillPlane": "#fbafea",
            "tagfillPlaneCancled": "#fbafea26",
            "tagfillRail": "#42a5f5",
            "tagfillRailCancled": "#42a5f526",
            "tagfillTaxi": "#ffe082",
            "tagfillTaxiCancled": "#ffe08226",
            "tagfillTrain": "#42a5f5",
            "tagfillTrainCancled": "#42a5f526",
            "tagfillTram": "#b482fb",
            "tagfillTramCancled": "#b482fb26",
            "tagfillWalk": "#8284ab",
            "tagfillWater": "#6fdfff",
            "tagfillWaterCancled": "#6fdfff26",
            "tagfillAirportlinkbusCancled": "#fbafea26",
            "tagfillAirportlinkbusCancled2": "#fbafea26",
            "tagfillAirportlinkrail": "#fbafea",
            "tagfillAirportlinkrailCancled": "#fbafea26",
            "tagfillAirportlinkbus": "#fbafea",
            "textCancled": "#b6b8ba",
            "textLabel": "#ffffff",
            "textLine": "#181c56",
            "textLineBusCancled": "#ff6392",
            "textLineCablewayCancled": "#b482fb",
            "textLineCarferryCancled": "#6fdfff",
            "textLineFerryCancled": "#6fdfff",
            "textLineFunicularCancled": "#b482fb",
            "textLineHelicopterCancled": "#fbafea",
            "textLineMetroCancled": "#f08901",
            "textLinePlaneCancled": "#fbafea",
            "textLineTaxiCancled": "#ffe082",
            "textLineTrainCancled": "#42a5f5",
            "textLineTramCancled": "#b482fb",
            "textLineAirportlinkbusCancled": "#fbafea",
            "textLineAirportlinkrailCancled": "#fbafea",
            "textNewtime": "#ff9494",
            "textWalk": "#181c56"
          },
          "standard": {
            "icon": "#ffffff",
            "iconBusCancled": "#c5044e",
            "iconCarferryCancled": "#0c6693",
            "iconFerryCancled": "#0c6693",
            "iconFunicularCancled": "#78469a",
            "iconHelicopterCancled": "#800664",
            "iconMetroCancled": "#bf5826",
            "iconPlaneCancled": "#800664",
            "iconTaxiCancled": "#3d3e40",
            "iconTrainCancled": "#00367f",
            "iconTramCancled": "#78469a",
            "iconWalk": "#181c56",
            "iconAirportlinkbusCancled": "#800664",
            "iconAirportlinkrailCancled": "#800664",
            "iconCablewayCancled": "#78469a",
            "iconborderValidation": "#ffffff",
            "tagfillAir": "#800664",
            "tagfillAirCancled": "#80066426",
            "tagfillBicycle": "#388f76",
            "tagfillBus": "#c5044e",
            "tagfillBusCancled": "#c5044e26",
            "tagfillCableway": "#78469a",
            "tagfillCablewayCancled": "#78469a26",
            "tagfillCarferry": "#0c6693",
            "tagfillCarferryCancled": "#0c669326",
            "tagfillCitybike": "#388f76",
            "tagfillFerry": "#0c6693",
            "tagfillFerryCancled": "#0c669326",
            "tagfillFunicular": "#78469a",
            "tagfillFunicularCancled": "#78469a26",
            "tagfillHelicopter": "#800664",
            "tagfillHelicopterCancled": "#80066426",
            "tagfillMetro": "#bf5826",
            "tagfillMetroCancled": "#bf582626",
            "tagfillMobility": "#388f76",
            "tagfillPlane": "#800664",
            "tagfillPlaneCancled": "#80066426",
            "tagfillRail": "#00367f",
            "tagfillRailCancled": "#00367f26",
            "tagfillTaxi": "#3d3e40",
            "tagfillTaxiCancled": "#3d3e4026",
            "tagfillTrain": "#00367f",
            "tagfillTrainCancled": "#00367f26",
            "tagfillTram": "#78469a",
            "tagfillTramCancled": "#78469a26",
            "tagfillWalk": "#e3e6e8",
            "tagfillWater": "#0c6693",
            "tagfillWaterCancled": "#0c669326",
            "tagfillAirportlinkbus": "#800664",
            "tagfillAirportlinkbusCancled": "#80066426",
            "tagfillAirportlinkrail": "#800664",
            "tagfillAirportlinkrailCancled": "#80066426",
            "textCancled": "#6e6f73",
            "textLabel": "#181c56",
            "textLine": "#ffffff",
            "textLineBusCancled": "#c5044e",
            "textLineCablewayCancled": "#78469a",
            "textLineCarferryCancled": "#0c6693",
            "textLineFerryCancled": "#0c6693",
            "textLineFunicularCancled": "#78469a",
            "textLineHelicopterCancled": "#800664",
            "textLineMetroCancled": "#bf5826",
            "textLinePlaneCancled": "#800664",
            "textLineTaxiCancled": "#3d3e40",
            "textLineTrainCancled": "#00367f",
            "textLineTramCancled": "#78469a",
            "textLineAirportlinkbusCancled": "#800664",
            "textLineAirportlinkrailCancled": "#800664",
            "textNewtime": "#d31b1b",
            "textWalk": "#181c56"
          }
        }
      },
      "typography": {
        "baseText": {
          "contrast": {
            "textAccent": "#ffffff"
          },
          "standard": {
            "textAccent": "#181c56"
          }
        },
        "blockquote": {
          "contrast": {
            "stroke": "#8284ab",
            "textAccent": "#ffffff",
            "textSubdued": "#d9dae8"
          },
          "standard": {
            "stroke": "#8284ab",
            "textAccent": "#181c56",
            "textSubdued": "#626493"
          }
        },
        "codeText": {
          "contrast": {
            "border": "#ffffff00",
            "borderInteractive": "#aeb7e2",
            "fill": "#f6f6f9",
            "text": "#181c56"
          },
          "standard": {
            "border": "#54568c66",
            "borderInteractive": "#181c56",
            "fill": "#f6f6f9",
            "text": "#181c56"
          }
        },
        "label": {
          "contrast": {
            "textAccent": "#d9dae8"
          },
          "standard": {
            "textAccent": "#626493"
          }
        },
        "list": {
          "contrast": {
            "border": "#aeb7e2",
            "textAccent": "#ffffff"
          },
          "standard": {
            "border": "#aeb7e2",
            "textAccent": "#181c56"
          }
        }
      }
    },
    "designentur": {
      "basecard": {
        "contrast": {
          "border": "#ffffff00",
          "fill": "#181c56",
          "fillTint": "#393d79",
          "text": "#ffffff"
        },
        "default": {
          "border": "#e5e5e9",
          "fill": "#f2f5f7",
          "fillTint": "#f6f6f9",
          "text": "#181c56"
        }
      },
      "dodontcard": {
        "fill": "#f6f6f9",
        "statuslineNegative": "#d31b1b",
        "statuslineSuccess": "#1a8e60",
        "statuslineWarning": "#ffca28",
        "text": "#181c56"
      },
      "footer": {
        "contrast": {
          "divider": "#e5e5e9",
          "fill": "#181c56",
          "text": "#ffffff",
          "textSubdued": "#d9dae8"
        },
        "default": {
          "divider": "#e5e5e9",
          "fill": "#f2f5f7",
          "text": "#181c56",
          "textSubdued": "#626493"
        }
      },
      "header": {
        "contrast": {
          "divider": "#ffffff00",
          "fill": "#181c56"
        },
        "default": {
          "divider": "#e3e6e8",
          "fill": "#ffffff"
        }
      },
      "logo": {
        "contrast": {
          "backgroundApp": "#ffffff",
          "highlight": "#ff5959",
          "text": "#ffffff",
          "textApp": "#181c56"
        },
        "standard": {
          "backgroundApp": "#181c56",
          "highlight": "#ff5959",
          "text": "#181c56",
          "textApp": "#ffffff"
        }
      },
      "npmtag": {
        "divide": "#949699",
        "text": "#6e6f73"
      },
      "playground": {
        "background": "#f6f6f9",
        "border": "#e3e6e8",
        "panel": "#ffffff",
        "text": "#181c56"
      },
      "typographycard": {
        "border": "#e3e6e8",
        "fill": "#ffffff",
        "text": "#181c56",
        "textSubdued": "#626493"
      }
    }
  },
  "dark": {
    "components": {
      "layout": {
        "badge": {
          "information": {
            "contrast": {
              "border": "#ffffff00",
              "bullet": "#acd7f1",
              "fill": "#acd7f1",
              "text": "#08091c",
              "textBullet": "#e5e5e9"
            },
            "standard": {
              "border": "#ffffff00",
              "bullet": "#acd7f1",
              "fill": "#acd7f1",
              "text": "#08091c",
              "textBullet": "#e5e5e9"
            }
          },
          "negative": {
            "contrast": {
              "border": "#ffffff00",
              "bullet": "#ff9494",
              "fill": "#ffcece",
              "text": "#08091c",
              "textBullet": "#e5e5e9"
            },
            "standard": {
              "border": "#ffffff00",
              "bullet": "#ff9494",
              "fill": "#ffcece",
              "text": "#08091c",
              "textBullet": "#e5e5e9"
            }
          },
          "neutral": {
            "contrast": {
              "border": "#ffffff00",
              "bullet": "#e5e5e9",
              "fill": "#e5e5e959",
              "text": "#e5e5e9",
              "textBullet": "#e5e5e9"
            },
            "standard": {
              "border": "#ffffff00",
              "bullet": "#e5e5e9",
              "fill": "#e5e5e959",
              "text": "#e5e5e9",
              "textBullet": "#e5e5e9"
            }
          },
          "primary": {
            "contrast": {
              "bullet": "#aeb7e2",
              "fill": "#aeb7e2",
              "text": "#08091c",
              "textBullet": "#e5e5e9"
            },
            "standard": {
              "bullet": "#aeb7e2",
              "fill": "#aeb7e2",
              "text": "#08091c",
              "textBullet": "#e5e5e9"
            }
          },
          "success": {
            "contrast": {
              "border": "#ffffff00",
              "bullet": "#9cd9c2",
              "fill": "#9cd9c2",
              "text": "#08091c",
              "textBullet": "#e5e5e9"
            },
            "standard": {
              "border": "#ffffff00",
              "bullet": "#9cd9c2",
              "fill": "#9cd9c2",
              "text": "#08091c",
              "textBullet": "#e5e5e9"
            }
          },
          "warning": {
            "contrast": {
              "border": "#ffffff00",
              "bullet": "#ffeeb3",
              "fill": "#ffeeb3",
              "text": "#08091c",
              "textBullet": "#e5e5e9"
            },
            "standard": {
              "border": "#ffffff00",
              "bullet": "#ffeeb3",
              "fill": "#ffeeb3",
              "text": "#08091c",
              "textBullet": "#e5e5e9"
            }
          }
        },
        "card": {
          "contrast": {
            "borderDefault": "#ffffff00",
            "borderActive": "#b3b4bd",
            "divide": "#ff5959",
            "fillDefaultSolid": "#393a49",
            "fillDefaultTransparent": "#e5e5e926",
            "fillHoveractive": "#464755",
            "icon": "#e5e5e9",
            "shadowLayer1": "#ffffff00",
            "shadowLayer2": "#ffffff00",
            "shadowLayer3": "#ffffff00",
            "subjectText": "#b3b4bd",
            "text": "#e5e5e9"
          },
          "standard": {
            "borderDefault": "#ffffff00",
            "borderActive": "#b3b4bd",
            "divide": "#ff5959",
            "fillDefaultSolid": "#393a49",
            "fillDefaultTransparent": "#e5e5e926",
            "fillHoveractive": "#464755",
            "icon": "#e5e5e9",
            "shadowLayer1": "#ffffff00",
            "shadowLayer2": "#ffffff00",
            "shadowLayer3": "#ffffff00",
            "subjectText": "#b3b4bd",
            "text": "#e5e5e9"
          }
        }
      },
      "alert": {
        "alertbox": {
          "information": {
            "contrast": {
              "border": "#067eb2",
              "fillDefault": "#2d98d233",
              "fillToast": "#acd7f1",
              "iconDefault": "#acd7f1",
              "iconToast": "#181c56",
              "textDefault": "#e5e5e9",
              "textToast": "#181c56"
            },
            "standard": {
              "border": "#067eb2",
              "fillDefault": "#2d98d233",
              "fillToast": "#acd7f1",
              "iconDefault": "#acd7f1",
              "iconToast": "#067eb2",
              "textDefault": "#e5e5e9",
              "textToast": "#181c56"
            }
          },
          "negative": {
            "contrast": {
              "border": "#d31b1b",
              "fillDefault": "#ff949433",
              "fillToast": "#ff9494",
              "iconDefault": "#ff9494",
              "iconToast": "#181c56",
              "textDefault": "#e5e5e9",
              "textToast": "#181c56"
            },
            "standard": {
              "border": "#d31b1b",
              "fillDefault": "#ff949433",
              "fillToast": "#ff9494",
              "iconDefault": "#ff9494",
              "iconToast": "#d31b1b",
              "textDefault": "#e5e5e9",
              "textToast": "#181c56"
            }
          },
          "success": {
            "contrast": {
              "border": "#1a8e60",
              "fillDefault": "#5ac39a33",
              "fillToast": "#9cd9c2",
              "iconDefault": "#9cd9c2",
              "iconToast": "#181c56",
              "textDefault": "#e5e5e9",
              "textToast": "#181c56"
            },
            "standard": {
              "border": "#1a8e60",
              "fillDefault": "#5ac39a33",
              "fillToast": "#9cd9c2",
              "iconDefault": "#9cd9c2",
              "iconToast": "#1a8e60",
              "textDefault": "#e5e5e9",
              "textToast": "#181c56"
            }
          },
          "warning": {
            "contrast": {
              "border": "#e9b10c",
              "fillDefault": "#ffe08240",
              "fillToast": "#ffeeb3",
              "iconDefault": "#181c56",
              "iconToast": "#181c56",
              "textDefault": "#e5e5e9",
              "textDefault2": "#e5e5e9"
            },
            "standard": {
              "border": "#e9b10c",
              "fillDefault": "#ffe08240",
              "fillToast": "#ffeeb3",
              "iconDefault": "#ffeeb3",
              "iconToast": "#181c56",
              "textDefault": "#e5e5e9",
              "textToast": "#181c56"
            }
          }
        },
        "copyableText": {
          "contrast": {
            "border": "#ffffff00",
            "borderInteractive": "#e5e5e9",
            "fill": "#393a49",
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          },
          "standard": {
            "border": "#ffffff00",
            "borderInteractive": "#e5e5e9",
            "fill": "#393a49",
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          }
        }
      },
      "button": {
        "disabled": {
          "contrast": {
            "fill": "#cfd2d41a",
            "iconDisabled": "#b6b8ba",
            "textDisabled": "#b6b8ba"
          },
          "standard": {
            "fill": "#cfd2d41a",
            "iconDisabled": "#b6b8ba",
            "textDisabled": "#b6b8ba"
          }
        },
        "floating": {
          "contrast": {
            "active": "#8794d4",
            "default": "#aeb7e2",
            "hover": "#c7cdeb",
            "icon": "#08091c",
            "text": "#08091c"
          },
          "standard": {
            "active": "#8794d4",
            "default": "#aeb7e2",
            "hover": "#c7cdeb",
            "icon": "#08091c",
            "text": "#08091c"
          }
        },
        "iconButton": {
          "contrast": {
            "active": "#8794d4",
            "default": "#ffffff00",
            "hover": "#626493",
            "icon": "#e5e5e9",
            "iconActive": "#08091c",
            "text": "#e5e5e9",
            "textActive": "#08091c"
          },
          "standard": {
            "active": "#8794d4",
            "default": "#ffffff00",
            "hover": "#626493",
            "icon": "#e5e5e9",
            "iconActive": "#08091c",
            "text": "#e5e5e9",
            "textActive": "#08091c"
          }
        },
        "negative": {
          "contrast": {
            "active": "#ff9494",
            "border": "#ff9494",
            "default": "#ffffff00",
            "hover": "#ff949433",
            "icon": "#e5e5e9",
            "iconActive": "#08091c",
            "text": "#e5e5e9",
            "textActive": "#08091c"
          },
          "standard": {
            "active": "#ff9494",
            "border": "#ff9494",
            "default": "#ffffff00",
            "hover": "#ff949433",
            "icon": "#e5e5e9",
            "iconActive": "#08091c",
            "text": "#e5e5e9",
            "textActive": "#08091c"
          }
        },
        "primary": {
          "contrast": {
            "active": "#8794d4",
            "default": "#aeb7e2",
            "hover": "#c7cdeb",
            "icon": "#08091c",
            "text": "#08091c"
          },
          "standard": {
            "active": "#8794d4",
            "default": "#aeb7e2",
            "hover": "#c7cdeb",
            "icon": "#08091c",
            "text": "#08091c"
          }
        },
        "secondary": {
          "contrast": {
            "active": "#8794d4",
            "border": "#8284ab",
            "borderActive": "#ffffff00",
            "default": "#ffffff00",
            "hover": "#626493",
            "icon": "#e5e5e9",
            "iconActive": "#08091c",
            "text": "#e5e5e9",
            "textActive": "#08091c"
          },
          "standard": {
            "active": "#8794d4",
            "border": "#8284ab",
            "borderActive": "#ffffff00",
            "default": "#ffffff00",
            "hover": "#626493",
            "icon": "#e5e5e9",
            "iconActive": "#08091c",
            "text": "#e5e5e9",
            "textActive": "#08091c"
          }
        },
        "squareSecondary": {
          "contrast": {
            "active": "#8794d4",
            "border": "#8284ab",
            "borderActive": "#ffffff00",
            "default": "#ffffff00",
            "hover": "#626493",
            "iconActive": "#08091c",
            "iconDefault": "#e5e5e9",
            "iconHover": "#e5e5e9",
            "label": "#e5e5e9"
          },
          "standard": {
            "active": "#8794d4",
            "border": "#8284ab",
            "borderActive": "#ffffff00",
            "default": "#ffffff00",
            "hover": "#626493",
            "icon": "#e5e5e9",
            "iconActive": "#08091c",
            "text": "#e5e5e9"
          }
        },
        "squareSuccess": {
          "contrast": {
            "active": "#5ac39a",
            "border": "#ffffff00",
            "default": "#5ac39a",
            "hover": "#9cd9c2",
            "icon": "#08091c",
            "label": "#e5e5e9"
          },
          "standard": {
            "active": "#37ab83",
            "border": "#ffffff00",
            "default": "#5ac39a",
            "hover": "#9cd9c2",
            "icon": "#08091c",
            "label": "#e5e5e9"
          }
        },
        "success": {
          "contrast": {
            "active": "#37ab83",
            "border": "#ffffff00",
            "default": "#5ac39a",
            "hover": "#9cd9c2",
            "icon": "#08091c",
            "text": "#08091c"
          },
          "standard": {
            "active": "#37ab83",
            "border": "#ffffff00",
            "default": "#5ac39a",
            "hover": "#9cd9c2",
            "icon": "#08091c",
            "text": "#08091c"
          }
        }
      },
      "chip": {
        "contrast": {
          "active": "#8794d4",
          "border": "#aeb7e2b2",
          "borderDisabled": "#949699",
          "default": "#ffffff00",
          "hover": "#626493",
          "iconDisabled": "#b6b8ba",
          "iconSelected": "#08091c",
          "iconUnselected": "#e5e5e9",
          "textDisabled": "#b6b8ba",
          "textSelected": "#08091c",
          "textUnselected": "#e5e5e9"
        },
        "standard": {
          "active": "#8794d4",
          "border": "#aeb7e2b2",
          "borderDisabled": "#949699",
          "default": "#ffffff00",
          "hover": "#626493",
          "iconDisabled": "#b6b8ba",
          "iconSelected": "#08091c",
          "iconUnselected": "#e5e5e9",
          "textDisabled": "#b6b8ba",
          "textSelected": "#08091c",
          "textUnselected": "#e5e5e9"
        }
      },
      "datepicker": {
        "calendar": {
          "background": "#393a49",
          "border": "#ffffff00",
          "dateborder": "#81828f",
          "datefillHover": "#e5e5e959",
          "datefillSelected": "#e5e5e926",
          "icon": "#e5e5e9",
          "strokeToday": "#ff9494",
          "textAccent": "#e5e5e9",
          "textDisabled": "#6e6f73",
          "textSubdued": "#b3b4bd"
        }
      },
      "expand": {
        "expandablePanel": {
          "contrast": {
            "fillDefault": "#e5e5e926",
            "fillHover": "#393a49",
            "fillSelected": "#e5e5e926",
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          },
          "standard": {
            "fillDefault": "#e5e5e926",
            "fillHover": "#393a49",
            "fillSelected": "#e5e5e926",
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          }
        },
        "expandableText": {
          "contrast": {
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          },
          "standard": {
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          }
        }
      },
      "form": {
        "baseForm": {
          "contrast": {
            "borderDefault": "#8284ab",
            "borderInteractive": "#aeb7e2",
            "borderNegative": "#ff9494",
            "borderSuccess": "#5ac39a",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cfd2d426",
            "fillReadonly": "#ffffff00",
            "icon": "#e5e5e9",
            "iconDisabled": "#6e6f73",
            "textContent": "#e5e5e9",
            "textDescription": "#e5e5e9",
            "textLabel": "#b3b4bd",
            "textDisabled": "#6e6f73"
          },
          "standard": {
            "borderDefault": "#8284ab",
            "borderInteractive": "#aeb7e2",
            "borderNegative": "#ff9494",
            "borderSuccess": "#5ac39a",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cfd2d426",
            "fillReadonly": "#ffffff00",
            "icon": "#e5e5e9",
            "iconDisabled": "#6e6f73",
            "textContent": "#e5e5e9",
            "textDescription": "#e5e5e9",
            "textLabel": "#b3b4bd",
            "textDisabled": "#6e6f73"
          }
        },
        "baseMenu": {
          "border": "#ffffff00",
          "fillDefault": "#464755",
          "fillHover": "#626493",
          "fillSelected": "#8794d4",
          "icon": "#e5e5e9",
          "iconDisabled": "#949699",
          "text": "#e5e5e9",
          "textDisabled": "#949699"
        },
        "basePanel": {
          "contrast": {
            "borderDefault": "#81828f",
            "borderDisabled": "#949699",
            "borderSelected": "#aeb7e2",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cfd2d426",
            "fillExpired": "#ff949433",
            "fillHover": "#393a49",
            "fillSelected": "#e5e5e926",
            "textAccent": "#e5e5e9",
            "textDisabled": "#b6b8ba",
            "textRebate": "#5ac39a",
            "textSubdued": "#b3b4bd"
          },
          "standard": {
            "borderDefault": "#81828f",
            "borderDisabled": "#949699",
            "borderSelected": "#aeb7e2",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cfd2d426",
            "fillExpired": "#ff949433",
            "fillHover": "#393a49",
            "fillSelected": "#e5e5e926",
            "textAccent": "#e5e5e9",
            "textDisabled": "#b6b8ba",
            "textRebate": "#5ac39a",
            "textSubdued": "#b3b4bd"
          }
        },
        "checkbox": {
          "contrast": {
            "border": "#aeb7e2",
            "borderDisabled": "#6e6f73",
            "borderNegative": "#ff9494",
            "borderReadonly": "#6e6f73",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cccdd44d",
            "fillHover": "#626493",
            "fillSelected": "#aeb7e2",
            "fillSelectedhover": "#c7cdeb",
            "icon": "#181c56",
            "iconDisabled": "#6e6f73",
            "iconReadonly": "#e5e5e9",
            "text": "#e5e5e9",
            "textDisabled": "#6e6f73"
          },
          "standard": {
            "border": "#aeb7e2",
            "borderDisabled": "#6e6f73",
            "borderNegative": "#ff9494",
            "borderReadonly": "#6e6f73",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cfd2d426",
            "fillHover": "#626493",
            "fillSelected": "#aeb7e2",
            "fillSelectedhover": "#c7cdeb",
            "icon": "#181c56",
            "iconDisabled": "#6e6f73",
            "iconReadonly": "#e5e5e9",
            "text": "#e5e5e9",
            "textDisabled": "#6e6f73"
          }
        },
        "feedbackText": {
          "information": {
            "contrast": {
              "iconFill": "#64b3e7",
              "iconSymbol": "#08091c",
              "stroke": "#08091c",
              "text": "#e5e5e9"
            },
            "standard": {
              "iconFill": "#64b3e7",
              "iconSymbol": "#08091c",
              "stroke": "#08091c",
              "text": "#e5e5e9"
            }
          },
          "negative": {
            "contrast": {
              "iconFill": "#ff9494",
              "iconSymbol": "#08091c",
              "stroke": "#08091c",
              "text": "#e5e5e9"
            },
            "standard": {
              "iconFill": "#ff9494",
              "stroke": "#08091c",
              "symbol": "#08091c",
              "text": "#e5e5e9"
            }
          },
          "success": {
            "contrast": {
              "iconFill": "#5ac39a",
              "iconStroke": "#08091c",
              "iconSymbol": "#08091c",
              "text": "#e5e5e9"
            },
            "standard": {
              "iconFill": "#5ac39a",
              "iconStroke": "#08091c",
              "iconSymbol": "#08091c",
              "text": "#e5e5e9"
            }
          },
          "warning": {
            "contrast": {
              "icon": "#ffe082",
              "iconSymbol": "#08091c",
              "stroke": "#08091c",
              "text": "#e5e5e9"
            },
            "standard": {
              "iconFill": "#ffe082",
              "iconSymbol": "#08091c",
              "stroke": "#08091c",
              "text": "#e5e5e9"
            }
          }
        },
        "radio": {
          "contrast": {
            "border": "#aeb7e2",
            "borderDisabled": "#6e6f73",
            "borderNegative": "#ff9494",
            "borderReadonly": "#6e6f73",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cccdd44d",
            "fillHover": "#626493",
            "fillSelected": "#aeb7e2",
            "fillSelectedhover": "#c7cdeb",
            "icon": "#e5e5e9",
            "iconDisabled": "#6e6f73",
            "iconReadonly": "#e5e5e9",
            "text": "#e5e5e9",
            "textDisabled": "#6e6f73"
          },
          "standard": {
            "border": "#aeb7e2",
            "borderDisabled": "#6e6f73",
            "borderNegative": "#ff9494",
            "borderReadonly": "#6e6f73",
            "fillDefault": "#ffffff00",
            "fillDisabled": "#cfd2d426",
            "fillHover": "#626493",
            "fillSelected": "#aeb7e2",
            "icon": "#e5e5e9",
            "iconDisabled": "#6e6f73",
            "iconReadonly": "#e5e5e9",
            "selectedhover": "#c7cdeb",
            "text": "#e5e5e9",
            "textDisabled": "#6e6f73"
          }
        },
        "segmentedControl": {
          "contrast": {
            "background": "#e5e5e926",
            "fillHover": "#e5e5e926",
            "fillSelected": "#e5e5e9",
            "fillUnselected": "#ffffff00",
            "iconSelected": "#08091c",
            "iconUnselected": "#e5e5e9",
            "textSelected": "#08091c",
            "textUnselected": "#e5e5e9"
          },
          "standard": {
            "background": "#e5e5e926",
            "fillHover": "#e5e5e926",
            "fillSelected": "#e5e5e9",
            "fillUnselected": "#ffffff00",
            "iconSelected": "#08091c",
            "iconUnselected": "#e5e5e9",
            "textSelected": "#08091c",
            "textUnselected": "#e5e5e9"
          }
        },
        "switch": {
          "contrast": {
            "fillFalse": "#e5e5e959",
            "fillTrue": "#5ac39a",
            "iconFalse": "#b3b4bd",
            "iconTrue": "#e5e5e9",
            "switch": "#08091c",
            "text": "#e5e5e9"
          },
          "standard": {
            "fillFalse": "#e5e5e959",
            "fillTrue": "#5ac39a",
            "iconFalse": "#b3b4bd",
            "iconTrue": "#e5e5e9",
            "switch": "#08091c",
            "text": "#e5e5e9"
          }
        }
      },
      "loader": {
        "fileupload": {
          "contrast": {
            "fillDefault": "#ffffff00",
            "icon": "#e5e5e9",
            "iconDisabled": "#949699",
            "strokeDefault": "#8284ab",
            "strokeDisabled": "#81828f",
            "strokeNegative": "#ff9494",
            "strokeSuccess": "#5ac39a",
            "text": "#e5e5e9",
            "textDisabled": "#949699"
          },
          "standard": {
            "fillDefault": "#ffffff00",
            "icon": "#e5e5e9",
            "iconDisabled": "#949699",
            "strokeDefault": "#8284ab",
            "strokeDisabled": "#81828f",
            "strokeNegative": "#ff9494",
            "strokeSuccess": "#5ac39a",
            "text": "#e5e5e9",
            "textDisabled": "#949699"
          }
        },
        "loader": {
          "contrast": {
            "border": "#81828f",
            "progressbar": "#ff9494",
            "text": "#e5e5e9"
          },
          "standard": {
            "border": "#81828f",
            "progressbar": "#ff9494",
            "text": "#e5e5e9"
          }
        },
        "spinner": {
          "contrast": {
            "fill": "#e5e5e9"
          },
          "standard": {
            "fill": "#e5e5e9"
          }
        },
        "skeleton": {
          "contrast": {
            "fill": "#2d2e3e",
            "highlight": "#141527"
          },
          "standard": {
            "fill": "#2d2e3e",
            "highlight": "#141527"
          }
        }
      },
      "menu": {
        "breadcrumb": {
          "contrast": {
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          },
          "standard": {
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          }
        },
        "navigationBar": {
          "contrast": {
            "background": "#393a49",
            "divide": "#ffffff00",
            "iconSelected": "#e5e5e9",
            "iconUnselected": "#b6b8ba",
            "strokeSelected": "#ff9494",
            "textSelected": "#e5e5e9",
            "textUnselected": "#b6b8ba"
          },
          "standard": {
            "background": "#393a49",
            "divide": "#ffffff00",
            "iconSelected": "#e5e5e9",
            "iconUnselected": "#b6b8ba",
            "strokeSelected": "#ff9494",
            "textSelected": "#e5e5e9",
            "textUnselected": "#b6b8ba"
          }
        },
        "navigationLink": {
          "contrast": {
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          },
          "standard": {
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          }
        },
        "overflowMenu": {
          "border": "#ffffff00",
          "fillActive": "#8794d4",
          "fillDefault": "#464755",
          "fillHover": "#626493",
          "icon": "#e5e5e9",
          "iconDisabled": "#949699",
          "text": "#e5e5e9",
          "textDisabled": "#949699"
        },
        "pagination": {
          "contrast": {
            "active": "#8794d4",
            "borderSelected": "#e5e5e9",
            "borderUnselected": "#aeb7e2b2",
            "default": "#ffffff00",
            "hover": "#626493",
            "icon": "#e5e5e9",
            "textSelected": "#08091c",
            "textSubdued": "#b3b4bd",
            "textUnselected": "#e5e5e9"
          },
          "standard": {
            "active": "#8794d4",
            "borderSelected": "#e5e5e9",
            "borderUnselected": "#aeb7e2b2",
            "default": "#ffffff00",
            "hover": "#626493",
            "icon": "#e5e5e9",
            "textSelected": "#08091c",
            "textSubdued": "#b3b4bd",
            "textUnselected": "#e5e5e9"
          }
        },
        "sideNavigation": {
          "contrast": {
            "avatar": "#e5e5e926",
            "background": "#212233",
            "divide": "#81828f",
            "fillActive": "#ffffff00",
            "fillDefault": "#ffffff00",
            "fillHover": "#e5e5e926",
            "icon": "#e5e5e9",
            "iconDisabled": "#949699",
            "iconLabel": "#b3b4bd",
            "label": "#b3b4bd",
            "strokeSelected": "#ff9494",
            "text": "#e5e5e9",
            "textDisabled": "#949699"
          },
          "standard": {
            "avatar": "#e5e5e926",
            "background": "#212233",
            "divide": "#81828f",
            "fillActive": "#ffffff00",
            "fillDefault": "#ffffff00",
            "fillHover": "#e5e5e926",
            "icon": "#e5e5e9",
            "iconDisabled": "#949699",
            "iconLabel": "#b3b4bd",
            "label": "#b3b4bd",
            "strokeSelected": "#ff9494",
            "text": "#e5e5e9",
            "textDisabled": "#949699"
          }
        },
        "stepper": {
          "contrast": {
            "background": "#626493",
            "progressbar": "#aeb7e2",
            "textCompleted": "#e5e5e9",
            "textUncompleted": "#b6b8ba"
          },
          "standard": {
            "background": "#626493",
            "progressbar": "#aeb7e2",
            "textCompleted": "#e5e5e9",
            "textUncompleted": "#b6b8ba"
          }
        },
        "tableOfContent": {
          "contrast": {
            "iconSelected": "#e5e5e9",
            "iconUnselected": "#b3b4bd",
            "strokeSelected": "#ff9494",
            "strokeUnselected": "#54568c66",
            "textSelected": "#e5e5e9",
            "textUnselected": "#b3b4bd"
          },
          "standard": {
            "iconSelected": "#e5e5e9",
            "iconUnselected": "#b3b4bd",
            "strokeSelected": "#ff9494",
            "strokeUnselected": "#54568c66",
            "textSelected": "#e5e5e9",
            "textUnselected": "#b3b4bd"
          }
        }
      },
      "modal": {
        "drawer": {
          "contrast": {
            "background": "#393a49",
            "text": "#e5e5e9"
          },
          "standard": {
            "background": "#393a49",
            "text": "#e5e5e9"
          }
        },
        "modal": {
          "contrast": {
            "border": "#ffffff00",
            "fill": "#464755",
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          },
          "standard": {
            "border": "#ffffff00",
            "fill": "#464755",
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          }
        }
      },
      "tab": {
        "contrast": {
          "border": "#81828f",
          "fillDisabled": "#cfd2d41a",
          "fillHover": "#393a49",
          "fillSelected": "#08091c",
          "fillUnselected": "#e5e5e940",
          "icon": "#e5e5e9",
          "iconDisabled": "#949699",
          "text": "#e5e5e9",
          "textDisabled": "#949699",
          "underlineSelected": "#ff9494"
        },
        "standard": {
          "border": "#81828f",
          "fillDisabled": "#cfd2d41a",
          "fillHover": "#393a49",
          "fillSelected": "#08091c",
          "fillUnselected": "#e5e5e940",
          "icon": "#e5e5e9",
          "iconDisabled": "#949699",
          "text": "#e5e5e9",
          "textDisabled": "#949699",
          "underlineSelected": "#ff9494"
        }
      },
      "table": {
        "contrast": {
          "cellFill": "#ffffff00",
          "cellFillHover": "#e5e5e926",
          "cellFillNegative": "#ff949433",
          "headerFill": "#08091c",
          "icon": "#e5e5e9",
          "stroke": "#81828f",
          "text": "#e5e5e9"
        },
        "standard": {
          "cellFill": "#ffffff00",
          "cellFillHover": "#e5e5e926",
          "fillNegative": "#ff949433",
          "headerFill": "#08091c",
          "icon": "#e5e5e9",
          "stroke": "#81828f",
          "text": "#e5e5e9"
        }
      },
      "tooltip": {
        "popover": {
          "contrast": {
            "border": "#ffffff00",
            "fill": "#393a49",
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          },
          "standard": {
            "border": "#ffffff00",
            "fill": "#393a49",
            "icon": "#e5e5e9",
            "text": "#e5e5e9"
          }
        },
        "tooltip": {
          "contrast": {
            "fill": "#393a49",
            "fillNegative": "#ff9494",
            "icon": "#e5e5e9",
            "iconNegative": "#08091c",
            "text": "#e5e5e9",
            "textNegative": "#08091c",
            "triangle": "#393a49",
            "triangleNegative": "#ff9494"
          },
          "standard": {
            "fill": "#393a49",
            "fillNegative": "#ff9494",
            "icon": "#e5e5e9",
            "iconNegative": "#08091c",
            "text": "#e5e5e9",
            "textNegative": "#08091c",
            "triangle": "#393a49",
            "triangleNegative": "#ff9494"
          }
        }
      },
      "travel": {
        "legLine": {
          "strokeLine": "#ff9494"
        },
        "seatmap": {
          "background": "#e5e5e926",
          "border": "#81828f",
          "borderReverse": "#ffffff00",
          "fillChosen": "#8794d4",
          "fillConfirm": "#9cd9c2",
          "fillConflict": "#ffeeb3",
          "fillExit": "#9cd9c2",
          "fillFree": "#c7cdeb",
          "fillHeadpillow": "#f6f6f9",
          "fillReverse": "#f6f6f9",
          "fillUnavailable": "#ffffff00",
          "fillWc": "#393a49",
          "fillWindow": "#acd7f1",
          "iconReverse": "#08091c",
          "iconWc": "#e5e5e9",
          "strokeChosen": "#81828f",
          "strokeConfirm": "#1a8e60",
          "strokeConflict": "#e9b10c",
          "strokeFree": "#81828f",
          "strokeUnavailable": "#81828f",
          "textChosen": "#08091c",
          "textFree": "#08091c",
          "textUnavailable": "#b3b4bd"
        },
        "travelHeader": {
          "contrast": {
            "strokeLine": "#ff9494",
            "text": "#e5e5e9"
          },
          "standard": {
            "strokeLine": "#ff9494",
            "text": "#e5e5e9"
          }
        },
        "travelLeg": {
          "contrast": {
            "air": "#f2b8e5",
            "airportlinkbus": "#f2b8e5",
            "airportlinkrail": "#f2b8e5",
            "bicycle": "#4db295",
            "bulletBorder": "#08091c",
            "bus": "#ef7398",
            "cableway": "#b898e5",
            "carferry": "#8ccfe2",
            "citybike": "#4db295",
            "ferry": "#8ccfe2",
            "funicular": "#b898e5",
            "helicopter": "#f2b8e5",
            "metro": "#dd973c",
            "mobility": "#4db295",
            "plane": "#f2b8e5",
            "rail": "#60a2d7",
            "taxi": "#ffe082",
            "train": "#60a2d7",
            "tram": "#b898e5",
            "walk": "#8d8e9c",
            "water": "#8ccfe2"
          },
          "standard": {
            "air": "#f2b8e5",
            "airportlinkbus": "#f2b8e5",
            "airportlinkrail": "#f2b8e5",
            "bicycle": "#4db295",
            "bulletBorder": "#08091c",
            "bus": "#ef7398",
            "cableway": "#b898e5",
            "carferry": "#8ccfe2",
            "citybike": "#4db295",
            "ferry": "#8ccfe2",
            "funicular": "#b898e5",
            "helicopter": "#f2b8e5",
            "metro": "#dd973c",
            "mobility": "#4db295",
            "plane": "#f2b8e5",
            "rail": "#60a2d7",
            "taxi": "#ffe082",
            "train": "#60a2d7",
            "tram": "#b898e5",
            "walk": "#8d8e9c",
            "water": "#8ccfe2"
          }
        },
        "travelSwitch": {
          "contrast": {
            "backgroundfalse": "#e5e5e959",
            "backgroundtrueAir": "#f2b8e5",
            "backgroundtrueBicycle": "#4db295",
            "backgroundtrueBus": "#ef7398",
            "backgroundtrueCableway": "#b898e5",
            "backgroundtrueCarferry": "#8ccfe2",
            "backgroundtrueCitybike": "#4db295",
            "backgroundtrueFerry": "#8ccfe2",
            "backgroundtrueFunicular": "#b898e5",
            "backgroundtrueHelicopter": "#f2b8e5",
            "backgroundtrueMetro": "#dd973c",
            "backgroundtrueMobility": "#4db295",
            "backgroundtruePlane": "#f2b8e5",
            "backgroundtrueRail": "#60a2d7",
            "backgroundtrueTaxi": "#ffe082",
            "backgroundtrueTrain": "#60a2d7",
            "backgroundtrueTram": "#b898e5",
            "backgroundtrueWalk": "#8d8e9c",
            "backgroundtrueWater": "#8ccfe2",
            "backgroundtrueAirportlinkbus": "#f2b8e5",
            "backgroundtrueAirportlinkrail": "#f2b8e5",
            "iconfalse": "#b3b4bd",
            "icontrueBicycle": "#4db295",
            "icontrueBus": "#ef7398",
            "icontrueCableway": "#b898e5",
            "icontrueCarferry": "#8ccfe2",
            "icontrueCitybike": "#4db295",
            "icontrueFerry": "#8ccfe2",
            "icontrueFunicular": "#b898e5",
            "icontrueHelicopter": "#f2b8e5",
            "icontrueMetro": "#dd973c",
            "icontrueMobility": "#4db295",
            "icontruePlane": "#f2b8e5",
            "icontrueTaxi": "#ffe082",
            "icontrueTrain": "#60a2d7",
            "icontrueTram": "#b898e5",
            "icontrueWalk": "#8d8e9c",
            "icontrueAirportlinkbus": "#f2b8e5",
            "icontrueAirportlinkrail": "#f2b8e5",
            "switchfillFalse": "#08091c",
            "switchfillTrue": "#08091c",
            "text": "#e5e5e9"
          },
          "standard": {
            "backgroundfalse": "#e5e5e959",
            "backgroundtrueAir": "#f2b8e5",
            "backgroundtrueBicycle": "#4db295",
            "backgroundtrueBus": "#ef7398",
            "backgroundtrueCableway": "#b898e5",
            "backgroundtrueCarferry": "#8ccfe2",
            "backgroundtrueCitybike": "#4db295",
            "backgroundtrueFerry": "#8ccfe2",
            "backgroundtrueFunicular": "#b898e5",
            "backgroundtrueHelicopter": "#f2b8e5",
            "backgroundtrueMetro": "#dd973c",
            "backgroundtrueMobility": "#4db295",
            "backgroundtruePlane": "#f2b8e5",
            "backgroundtrueRail": "#60a2d7",
            "backgroundtrueTaxi": "#ffe082",
            "backgroundtrueTrain": "#60a2d7",
            "backgroundtrueTram": "#b898e5",
            "backgroundtrueWalk": "#8d8e9c",
            "backgroundtrueWater": "#8ccfe2",
            "backgroundtrueAirportlinkbus": "#f2b8e5",
            "backgroundtrueAirportlinkrail": "#f2b8e5",
            "iconfalse": "#b3b4bd",
            "icontrueBicycle": "#00db9b",
            "icontrueBus": "#ef7398",
            "icontrueCableway": "#b898e5",
            "icontrueCarferry": "#8ccfe2",
            "icontrueCitybike": "#00db9b",
            "icontrueFerry": "#8ccfe2",
            "icontrueFunicular": "#b898e5",
            "icontrueHelicopter": "#f2b8e5",
            "icontrueMetro": "#dd973c",
            "icontrueMobility": "#00db9b",
            "icontruePlane": "#f2b8e5",
            "icontrueRail": "#60a2d7",
            "icontrueTaxi": "#ffe082",
            "icontrueTrain": "#60a2d7",
            "icontrueTram": "#b898e5",
            "icontrueWalk": "#8d8e9c",
            "icontrueWater": "#8ccfe2",
            "icontrueAirportlinkbus": "#f2b8e5",
            "icontrueAirportlinkbus2": "#f2b8e5",
            "icontrueAirportlinkrail": "#f2b8e5",
            "switchfillFalse": "#08091c",
            "switchfillTrue": "#08091c",
            "text": "#e5e5e9"
          }
        },
        "travelTag": {
          "contrast": {
            "icon": "#08091c",
            "iconBusCancled": "#ef7398",
            "iconCabllewayCancled": "#b898e5",
            "iconCarferryCancled": "#8ccfe2",
            "iconFerryCancled": "#8ccfe2",
            "iconFunicularCancled": "#b898e5",
            "iconHelicopterCancled": "#f2b8e5",
            "iconMetroCancled": "#dd973c",
            "iconPlaneCancled": "#f2b8e5",
            "iconTaxiCancled": "#ffe082",
            "iconTrainCancled": "#60a2d7",
            "iconTramCancled": "#b898e5",
            "iconWalk": "#e5e5e9",
            "iconAirportlinkbusCancled": "#f2b8e5",
            "iconAirportlinkrailCancled": "#f2b8e5",
            "iconborderValidation": "#08091c",
            "tagfillAir": "#f2b8e5",
            "tagfillBicycle": "#4db295",
            "tagfillBus": "#ef7398",
            "tagfillBusCancled": "#ef739826",
            "tagfillCableway": "#b898e5",
            "tagfillCablewayCancled": "#b898e526",
            "tagfillCarferry": "#8ccfe2",
            "tagfillCarferryCancled": "#8ccfe226",
            "tagfillCitybike": "#4db295",
            "tagfillFerry": "#8ccfe2",
            "tagfillFerryCancled": "#8ccfe226",
            "tagfillFunicular": "#b898e5",
            "tagfillFunicularCancled": "#b898e526",
            "tagfillHelicopter": "#f2b8e5",
            "tagfillHelicopterCancled": "#f2b8e526",
            "tagfillMetro": "#dd973c",
            "tagfillMetroCancled": "#dd973c26",
            "tagfillMobility": "#4db295",
            "tagfillPlane": "#f2b8e5",
            "tagfillPlaneCancled": "#f2b8e526",
            "tagfillRail": "#60a2d7",
            "tagfillRailCancled": "#60a2d726",
            "tagfillTaxi": "#ffe082",
            "tagfillTaxiCancled": "#ffe08226",
            "tagfillTrain": "#60a2d7",
            "tagfillTrainCancled": "#60a2d726",
            "tagfillTram": "#b898e5",
            "tagfillTramCancled": "#b898e526",
            "tagfillWalk": "#8d8e9c",
            "tagfillWater": "#8ccfe2",
            "tagfillWaterCancled": "#8ccfe226",
            "tagfillAirportlinkbusCancled": "#f2b8e526",
            "tagfillAirportlinkbusCancled2": "#f2b8e526",
            "tagfillAirportlinkrail": "#f2b8e5",
            "tagfillAirportlinkrailCancled": "#f2b8e526",
            "tagfillAirportlinkbus": "#f2b8e5",
            "textCancled": "#b6b8ba",
            "textLabel": "#e5e5e9",
            "textLine": "#08091c",
            "textLineBusCancled": "#ef7398",
            "textLineCablewayCancled": "#b898e5",
            "textLineCarferryCancled": "#8ccfe2",
            "textLineFerryCancled": "#8ccfe2",
            "textLineFunicularCancled": "#b898e5",
            "textLineHelicopterCancled": "#f2b8e5",
            "textLineMetroCancled": "#dd973c",
            "textLinePlaneCancled": "#f2b8e5",
            "textLineTaxiCancled": "#ffe082",
            "textLineTrainCancled": "#60a2d7",
            "textLineTramCancled": "#b898e5",
            "textLineAirportlinkbusCancled": "#f2b8e5",
            "textLineAirportlinkrailCancled": "#f2b8e5",
            "textNewtime": "#ff9494",
            "textWalk": "#e5e5e9"
          },
          "standard": {
            "icon": "#08091c",
            "iconBusCancled": "#ef7398",
            "iconCarferryCancled": "#8ccfe2",
            "iconFerryCancled": "#8ccfe2",
            "iconFunicularCancled": "#b898e5",
            "iconHelicopterCancled": "#f2b8e5",
            "iconMetroCancled": "#dd973c",
            "iconPlaneCancled": "#f2b8e5",
            "iconTaxiCancled": "#ffe082",
            "iconTrainCancled": "#60a2d7",
            "iconTramCancled": "#b898e5",
            "iconWalk": "#08091c",
            "iconAirportlinkbusCancled": "#f2b8e5",
            "iconAirportlinkrailCancled": "#f2b8e5",
            "iconCablewayCancled": "#b898e5",
            "iconborderValidation": "#08091c",
            "tagfillAir": "#f2b8e5",
            "tagfillAirCancled": "#f2b8e526",
            "tagfillBicycle": "#4db295",
            "tagfillBus": "#ef7398",
            "tagfillBusCancled": "#ef739826",
            "tagfillCableway": "#b898e5",
            "tagfillCablewayCancled": "#b482fb26",
            "tagfillCarferry": "#8ccfe2",
            "tagfillCarferryCancled": "#8ccfe226",
            "tagfillCitybike": "#4db295",
            "tagfillFerry": "#8ccfe2",
            "tagfillFerryCancled": "#8ccfe226",
            "tagfillFunicular": "#b898e5",
            "tagfillFunicularCancled": "#b898e526",
            "tagfillHelicopter": "#f2b8e5",
            "tagfillHelicopterCancled": "#f2b8e526",
            "tagfillMetro": "#dd973c",
            "tagfillMetroCancled": "#dd973c26",
            "tagfillMobility": "#4db295",
            "tagfillPlane": "#f2b8e5",
            "tagfillPlaneCancled": "#f2b8e526",
            "tagfillRail": "#60a2d7",
            "tagfillRailCancled": "#60a2d726",
            "tagfillTaxi": "#ffe082",
            "tagfillTaxiCancled": "#ffe08226",
            "tagfillTrain": "#60a2d7",
            "tagfillTrainCancled": "#60a2d726",
            "tagfillTram": "#b898e5",
            "tagfillTramCancled": "#b898e526",
            "tagfillWalk": "#8d8e9c",
            "tagfillWater": "#8ccfe2",
            "tagfillWaterCancled": "#8ccfe226",
            "tagfillAirportlinkbus": "#f2b8e5",
            "tagfillAirportlinkbusCancled": "#f2b8e526",
            "tagfillAirportlinkrail": "#f2b8e5",
            "tagfillAirportlinkrailCancled": "#f2b8e526",
            "textCancled": "#b6b8ba",
            "textLabel": "#e5e5e9",
            "textLine": "#08091c",
            "textLineBusCancled": "#ef7398",
            "textLineCablewayCancled": "#b898e5",
            "textLineCarferryCancled": "#8ccfe2",
            "textLineFerryCancled": "#8ccfe2",
            "textLineFunicularCancled": "#b898e5",
            "textLineHelicopterCancled": "#f2b8e5",
            "textLineMetroCancled": "#dd973c",
            "textLinePlaneCancled": "#f2b8e5",
            "textLineTaxiCancled": "#ffe082",
            "textLineTrainCancled": "#60a2d7",
            "textLineTramCancled": "#b898e5",
            "textLineAirportlinkbusCancled": "#f2b8e5",
            "textLineAirportlinkrailCancled": "#f2b8e5",
            "textNewtime": "#ff9494",
            "textWalk": "#08091c"
          }
        }
      },
      "typography": {
        "baseText": {
          "contrast": {
            "textAccent": "#e5e5e9"
          },
          "standard": {
            "textAccent": "#e5e5e9"
          }
        },
        "blockquote": {
          "contrast": {
            "stroke": "#81828f",
            "textAccent": "#e5e5e9",
            "textSubdued": "#b3b4bd"
          },
          "standard": {
            "stroke": "#81828f",
            "textAccent": "#e5e5e9",
            "textSubdued": "#b3b4bd"
          }
        },
        "codeText": {
          "contrast": {
            "border": "#ffffff00",
            "borderInteractive": "#e5e5e9",
            "fill": "#393a49",
            "text": "#e5e5e9"
          },
          "standard": {
            "border": "#ffffff00",
            "borderInteractive": "#e5e5e9",
            "fill": "#393a49",
            "text": "#e5e5e9"
          }
        },
        "label": {
          "contrast": {
            "textAccent": "#e5e5e9"
          },
          "standard": {
            "textAccent": "#e5e5e9"
          }
        },
        "list": {
          "contrast": {
            "border": "#aeb7e2",
            "textAccent": "#e5e5e9"
          },
          "standard": {
            "border": "#aeb7e2",
            "textAccent": "#e5e5e9"
          }
        }
      }
    },
    "designentur": {
      "basecard": {
        "contrast": {
          "border": "#81828f",
          "fill": "#e5e5e926",
          "fillTint": "#e5e5e940",
          "text": "#e5e5e9"
        },
        "default": {
          "border": "#81828f",
          "fill": "#e5e5e926",
          "fillTint": "#e5e5e940",
          "text": "#e5e5e9"
        }
      },
      "dodontcard": {
        "fill": "#e5e5e926",
        "statuslineNegative": "#ff9494",
        "statuslineSuccess": "#9cd9c2",
        "statuslineWarning": "#ffeeb3",
        "text": "#e5e5e9"
      },
      "footer": {
        "contrast": {
          "divider": "#81828f",
          "fill": "#2d2e3e",
          "text": "#e5e5e9",
          "textSubdued": "#b3b4bd"
        },
        "default": {
          "divider": "#81828f",
          "fill": "#2d2e3e",
          "text": "#e5e5e9",
          "textSubdued": "#b3b4bd"
        }
      },
      "header": {
        "contrast": {
          "divider": "#81828f",
          "fill": "#08091c"
        },
        "default": {
          "divider": "#81828f",
          "fill": "#08091c"
        }
      },
      "logo": {
        "contrast": {
          "backgroundApp": "#e5e5e926",
          "highlight": "#ff5959",
          "text": "#ffffff",
          "textApp": "#ffffff"
        },
        "standard": {
          "backgroundApp": "#e5e5e926",
          "highlight": "#ff5959",
          "text": "#ffffff",
          "textApp": "#ffffff"
        }
      },
      "npmtag": {
        "divide": "#e5e5e9",
        "text": "#e5e5e9"
      },
      "playground": {
        "background": "#141527",
        "border": "#b3b4bd",
        "panel": "#e5e5e926",
        "text": "#e5e5e9"
      },
      "typographycard": {
        "border": "#b3b4bd",
        "fill": "#e5e5e926",
        "text": "#e5e5e9",
        "textSubdued": "#b3b4bd"
      }
    }
  }
};

/*
  Entur Design Tokens

  Hi there 👋 This file contains all the design tokens used in the Entur
  Linje. It's broken up into a few different sections:

  - colors
  - typography
  - dimensions
  - responsivity

  It's the source of truth of our design system, and any change here should be
  made in sync with our design team.
*/
var pxToRem = function pxToRem(pxValue) {
  return pxValue / 16;
};
var colors = {
  brand: {
    blue: '#181c56',
    lavender: '#aeb7e2',
    white: '#ffffff',
    coral: '#ff5959',
    peach: '#ffbf9e'
  },
  blues: {
    blue10: '#292b6a',
    blue20: '#393d79',
    blue30: '#54568c',
    blue40: '#656782',
    blue45: '#7C7F9F',
    blue50: '#8285a8',
    blue60: '#babbcf',
    blue70: '#d1d4e3',
    blue80: '#ebebf1',
    blue90: '#f5f5f8'
  },
  greys: {
    grey: '#121212',
    grey10: '#2a2a2a',
    grey20: '#353535',
    grey30: '#4d4d4d',
    grey40: '#646464',
    grey45: '#808080',
    grey50: '#949494',
    grey60: '#d1d3d3',
    grey70: '#e9e9e9',
    grey80: '#f3f3f3',
    grey90: '#f8f8f8'
  },
  validation: {
    sky: '#0082b9',
    skyContrast: '#64b3e7',
    skyTint: '#e1eff8',
    lava: '#d31b1b',
    lavaContrast: '#ff9494',
    lavaTint: '#ffcece',
    mint: '#1a8e60',
    mintContrast: '#5ac39a',
    mintTint: '#d0f1e3',
    // The best name
    canary: '#ffca28',
    canaryContrast: '#ffe082',
    canaryTint: '#fff4cd'
  },
  misc: {
    focus: 'rgba(68, 192, 255, 0.5)',
    black: '#000000'
  },
  transport: {
    "default": {
      metro: '#bf5826',
      bus: '#c5044e',
      plane: '#800664',
      helicopter: '#800664',
      tram: '#642e88',
      funicular: '#642e88',
      cableway: '#642e88',
      taxi: '#3d3e40',
      bicycle: '#181c56',
      walk: '#8d8e9c',
      train: '#00367f',
      ferry: '#0c6693',
      carferry: '#0c6693',
      mobility: '#388f76'
    },
    contrast: {
      metro: '#f08901',
      bus: '#ff6392',
      plane: '#fbafea',
      helicopter: '#e258c3',
      tram: '#b482fb',
      funicular: '#a476e5',
      cableway: '#a476e5',
      taxi: '#ffe082',
      bicycle: '#ffffff',
      walk: '#8284ab',
      train: '#42a5f5',
      ferry: '#6fdfff',
      carferry: '#6fdfff',
      mobility: '#00db9b'
    }
  },
  data: {
    "default": {
      blue: '#181c56',
      coral: '#ff5959',
      jungle: '#0ea2a8',
      azure: '#2f98fa',
      lavender: '#8692ca',
      peach: '#ca825b',
      spring: '#57a257',
      lilac: '#8e57e3'
    },
    contrast: {
      blue: '#6C6EB7',
      coral: '#ff5959',
      jungle: '#0fc2b3',
      azure: '#64b2fb',
      lavender: '#aeb7e2',
      peach: '#ffbf9e',
      spring: '#7bc00b',
      lilac: '#ea8bea'
    }
  }
};
var blackRgb = /*#__PURE__*/hexRgb(colors.misc.black, {
  format: 'array'
}).toString().slice(0, -2);
var blue20Rgb = /*#__PURE__*/hexRgb(colors.blues.blue20, {
  format: 'array'
}).toString().slice(0, -2);
// Dimensions
var spaceScale = [0, 4, 8, 12, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96];
var space = {
  /** 0px */
  none: spaceScale[0],
  /** 16px (1rem) */
  "default": spaceScale[4],
  /** 4px (0.25rem) */
  extraSmall2: spaceScale[1],
  /** 8px (0.5rem) */
  extraSmall: spaceScale[2],
  /** 12px (0.75rem) */
  small: spaceScale[3],
  /** 16px (1rem) */
  medium: spaceScale[4],
  /** 24px (1.5rem) */
  large: spaceScale[5],
  /** 32px (2rem) */
  extraLarge: spaceScale[6],
  /** 40px (2.5rem) */
  extraLarge2: spaceScale[7],
  /** 48px (3rem) */
  extraLarge3: spaceScale[8],
  /** 56px (3.5rem) */
  extraLarge4: spaceScale[9],
  /** 64px (4rem) */
  extraLarge5: spaceScale[10],
  /** 72px (4.5rem) */
  extraLarge6: spaceScale[11],
  /** 80px (5rem) */
  extraLarge7: spaceScale[12],
  /** 88px (5.5rem) */
  extraLarge8: spaceScale[13],
  /** 96px (6rem) */
  extraLarge9: spaceScale[14],
  rem: {
    /**  0rem (0px) */
    none: /*#__PURE__*/pxToRem(spaceScale[0]),
    /** 1rem (16px) */
    "default": /*#__PURE__*/pxToRem(spaceScale[4]),
    /** 0.25rem (4px) */
    extraSmall2: /*#__PURE__*/pxToRem(spaceScale[1]),
    /** 0.5rem (8px)  */
    extraSmall: /*#__PURE__*/pxToRem(spaceScale[2]),
    /** 0.75rem (12px) */
    small: /*#__PURE__*/pxToRem(spaceScale[3]),
    /** 1rem (16px) */
    medium: /*#__PURE__*/pxToRem(spaceScale[4]),
    /** 1.5rem (24px) */
    large: /*#__PURE__*/pxToRem(spaceScale[5]),
    /** 2rem (32px) */
    extraLarge: /*#__PURE__*/pxToRem(spaceScale[6]),
    /** 2.5rem (40px) */
    extraLarge2: /*#__PURE__*/pxToRem(spaceScale[7]),
    /** 3rem (48px) */
    extraLarge3: /*#__PURE__*/pxToRem(spaceScale[8]),
    /** 3.5rem (56px) */
    extraLarge4: /*#__PURE__*/pxToRem(spaceScale[9]),
    /** 4rem (64px) */
    extraLarge5: /*#__PURE__*/pxToRem(spaceScale[10]),
    /**  4.5rem (72px) */
    extraLarge6: /*#__PURE__*/pxToRem(spaceScale[11]),
    /** 5rem (80px) */
    extraLarge7: /*#__PURE__*/pxToRem(spaceScale[12]),
    /**  5.5rem (88px) */
    extraLarge8: /*#__PURE__*/pxToRem(spaceScale[13]),
    /**  6rem (96px) */
    extraLarge9: /*#__PURE__*/pxToRem(spaceScale[14])
  }
};
// Typography
var fontWeights = {
  body: '500',
  heading: '600'
};
var fontSizeScale = [10, 12, 14, 16, 20, 24, 28, 32, 40];
var fontSizes = {
  /** 10px (0.625rem) */
  extraSmall: fontSizeScale[0],
  /** 12px (0.75rem) */
  small: fontSizeScale[1],
  /** 14px (0.875rem) */
  medium: fontSizeScale[2],
  /** 16px (1rem) */
  large: fontSizeScale[3],
  /** 20 px (1.25rem) */
  extraLarge: fontSizeScale[4],
  /** 24 px (1.5rem) */
  extraLarge2: fontSizeScale[5],
  /** 28 px (1.75rem) */
  extraLarge3: fontSizeScale[6],
  /** 32 px (2rem) */
  extraLarge4: fontSizeScale[7],
  /** 40 px (2.5rem) */
  extraLarge5: fontSizeScale[8],
  rem: {
    /** 0.625rem (10px) */
    extraSmall: /*#__PURE__*/pxToRem(fontSizeScale[0]),
    /** 0.75rem (12px) */
    small: /*#__PURE__*/pxToRem(fontSizeScale[1]),
    /** 0.875rem (14px) */
    medium: /*#__PURE__*/pxToRem(fontSizeScale[2]),
    /** 1rem (16px) */
    large: /*#__PURE__*/pxToRem(fontSizeScale[3]),
    /** 1.25rem (20px) */
    extraLarge: /*#__PURE__*/pxToRem(fontSizeScale[4]),
    /** 1.5rem (24px) */
    extraLarge2: /*#__PURE__*/pxToRem(fontSizeScale[5]),
    /** 1.75rem (28px) */
    extraLarge3: /*#__PURE__*/pxToRem(fontSizeScale[6]),
    /** 2rem (32px) */
    extraLarge4: /*#__PURE__*/pxToRem(fontSizeScale[7]),
    /** 2.5rem (40px) */
    extraLarge5: /*#__PURE__*/pxToRem(fontSizeScale[8])
  }
};
var lineHeightScale = [14, 16, 20, 22, 24, 28, 30, 36, 42, 48, 60];
var lineHeights = {
  /** 14px (0.875rem) */
  extraSmall: lineHeightScale[0],
  /** 16px (1rem) */
  small: lineHeightScale[1],
  /** 20px (1.25rem) */
  medium: lineHeightScale[2],
  /** 22px (1.375rem) */
  large: lineHeightScale[3],
  /** 24px (1.5rem) */
  extraLarge: lineHeightScale[4],
  /** 28px (1.75rem) */
  extraLarge2: lineHeightScale[5],
  /** 30px (1.875rem) */
  extraLarge3: lineHeightScale[6],
  /** 36px (2.25rem) */
  extraLarge4: lineHeightScale[7],
  /** 42px (2.625rem) */
  extraLarge5: lineHeightScale[8],
  /** 48px (3rem) */
  extraLarge6: lineHeightScale[9],
  /** 60px (3.75rem) */
  extraLarge7: lineHeightScale[10],
  rem: {
    /** 0.875rem (14px) */
    extraSmall: /*#__PURE__*/pxToRem(lineHeightScale[0]),
    /** 1rem (16px) */
    small: /*#__PURE__*/pxToRem(lineHeightScale[1]),
    /** 1.25rem (20px) */
    medium: /*#__PURE__*/pxToRem(lineHeightScale[2]),
    /** 1.375rem (22px) */
    large: /*#__PURE__*/pxToRem(lineHeightScale[3]),
    /** 1.5rem (24px) */
    extraLarge: /*#__PURE__*/pxToRem(lineHeightScale[4]),
    /** 1.75rem (28px) */
    extraLarge2: /*#__PURE__*/pxToRem(lineHeightScale[5]),
    /** 1.875rem (30px) */
    extraLarge3: /*#__PURE__*/pxToRem(lineHeightScale[6]),
    /** 2.25rem (36px) */
    extraLarge4: /*#__PURE__*/pxToRem(lineHeightScale[7]),
    /** 2.625rem (42px) */
    extraLarge5: /*#__PURE__*/pxToRem(lineHeightScale[8]),
    /** 3rem (48px) */
    extraLarge6: /*#__PURE__*/pxToRem(lineHeightScale[9]),
    /** 3.75rem (60px) */
    extraLarge7: /*#__PURE__*/pxToRem(lineHeightScale[10])
  }
};
// Responsivity
var breakpoints = {
  large: 800,
  extraLarge: 1200,
  rem: {
    large: /*#__PURE__*/pxToRem(800),
    extraLarge: /*#__PURE__*/pxToRem(1200)
  }
};
// Borders
var borderWidthScale = [1, 2, 4];
var borderWidths = {
  /** 2px (0.125rem) */
  "default": borderWidthScale[1],
  /** 1px (0.0625rem) */
  small: borderWidthScale[0],
  /** 2px (0.125rem) */
  medium: borderWidthScale[1],
  /** 4px (0.25rem) */
  large: borderWidthScale[2],
  rem: {
    /** 0.125rem (2px) */
    "default": /*#__PURE__*/pxToRem(borderWidthScale[1]),
    /** 0.0625rem (1px) */
    small: /*#__PURE__*/pxToRem(borderWidthScale[0]),
    /** 0.125rem (2px) */
    medium: /*#__PURE__*/pxToRem(borderWidthScale[1]),
    /** 0.25rem (4px) */
    large: /*#__PURE__*/pxToRem(borderWidthScale[2])
  }
};
var borderRadiusScale = [1, 4, 8];
var borderRadiuses = {
  /** 1 px (0.0625rem) */
  "default": borderRadiusScale[0],
  /** 1 px (0.0625rem) */
  small: borderRadiusScale[0],
  /** 4 px (0.25rem) */
  medium: borderRadiusScale[1],
  /** 8 px (0.5rem) */
  large: borderRadiusScale[2],
  rem: {
    /** 0.0625rem (1px) */
    "default": /*#__PURE__*/pxToRem(borderRadiusScale[0]),
    /** 0.0625rem (1px) */
    small: /*#__PURE__*/pxToRem(borderRadiusScale[0]),
    /** 0.25rem (4px) */
    medium: /*#__PURE__*/pxToRem(borderRadiusScale[1]),
    /** 0.5rem (8px) */
    large: /*#__PURE__*/pxToRem(borderRadiusScale[2])
  }
};
var shadows = {
  focus: "0 0 0 0.125rem " + colors.brand.white + ", 0 0 0 0.25rem " + colors.brand.blue,
  focusContrast: "0 0 0 0.125rem " + colors.brand.blue + ", 0 0 0 0.25rem " + colors.brand.white,
  cardShadow: "0 0.0625rem 0.1875rem 0 rgba(" + blackRgb + ", 0.12)",
  cardShadowHover: "0 0.125rem 1rem 0 rgba(" + blackRgb + ", 0.1)",
  cardShadowContrast: "0 0.0625rem 0.1875rem 0 rgba(" + blue20Rgb + ", 1)",
  cardShadowHoverContrast: "0 0.125rem 1rem 0 rgba(" + blue20Rgb + ", 1)",
  boxShadow: "0 0.0625rem 0.1875rem rgba(" + blackRgb + ", 0.25)",
  boxShadowContrast: "0 0.0625rem 0.1875rem rgba(" + blue20Rgb + ", 1)"
};
// Z-indexes
var zIndexScale = [-1, 0, 10, 20, 30, 40, 50];
var zIndexes = {
  behind: zIndexScale[0],
  "default": zIndexScale[1],
  sticky: zIndexScale[2],
  popover: zIndexScale[3],
  overlay: zIndexScale[4],
  modal: zIndexScale[5],
  toast: zIndexScale[6]
};
var timingScale = ['0.1s', '0.2s', '0.5s'];
var timings = {
  /** 0.1s */
  fast: timingScale[0],
  /** 0.2s */
  medium: timingScale[1],
  /** 0.5s */
  slow: timingScale[2]
};
var outlines = {
  focus: 2 + "px solid " + colors.brand.blue,
  focusContrast: 2 + "px solid " + colors.brand.white + " "
};
var outlineOffsetsConstants = [2];
var outlineOffsets = {
  /** 2px (0.125rem) */
  focus: outlineOffsetsConstants[0],
  rem: {
    /** 0.125rem (2px) */
    focus: /*#__PURE__*/pxToRem(outlineOffsetsConstants[0])
  }
};

var SUPPORTED_COLOR_MODES = ['light', 'dark'];
function createColorSet(fileData) {
  var colorsUnformated = JSON.parse(fileData);
  var colorsFormatedAndMappedToModes = colorsUnformated[0].values.reduce(function (allComponentColors, colorMode) {
    var colorsFormatedForMode = colorMode.color.map(function (color) {
      var colorNameInKebabCase = toKebabCase(color.name);
      var varNameInKebabCase = toKebabCase(color["var"]);
      var hexValue = color.value;
      var colorModeName = colorMode.mode.name.toLowerCase();
      var usesAlias = varNameInKebabCase !== '';
      return {
        css: {
          key: "--" + colorNameInKebabCase,
          value: usesAlias ? "var(--" + varNameInKebabCase + ")" : hexValue
        },
        scss: {
          key: "$" + colorNameInKebabCase,
          value: usesAlias ? "$" + varNameInKebabCase : hexValue,
          sanitizedValue: usesAlias ? "#{$" + varNameInKebabCase + "}" : hexValue
        },
        less: {
          key: "@" + colorNameInKebabCase,
          value: usesAlias ? "@" + varNameInKebabCase : hexValue
        },
        js: {
          key: "" + (SUPPORTED_COLOR_MODES.includes(colorModeName) ? colorModeName + '.' : '') + toFlattenedJSObjectKey(color.name),
          value: hexValue
        },
        mode: colorModeName,
        usesAlias: usesAlias
      };
    });
    return [].concat(allComponentColors, colorsFormatedForMode);
  }, []);
  return colorsFormatedAndMappedToModes;
}
var WARNING_TEXT = "/* DO NOT CHANGE!*/\n/* This file is automatically generated from @entur/tokens! Changes will be overwritten. */";
function createColorsOutputString(_ref) {
  var colorSet = _ref.colorSet,
    keyType = _ref.keyType,
    valueType = _ref.valueType,
    withColorMode = _ref.withColorMode,
    importFileNames = _ref.importFileNames;
  var needsRoot = keyType === 'css';
  var needsImport = colorSet.some(function (color) {
    return color.usesAlias;
  });
  if (withColorMode) {
    if (needsImport && importFileNames) {
      var importString = createImportStatementString({
        fileNames: importFileNames,
        extension: valueType,
        includeAs: needsImport && valueType === 'scss'
      });
      var colorVariablesString = stringWithColorMode(colorSet);
      return importString + "\n      " + colorVariablesString + "\n      ";
    }
    return stringWithColorMode(colorSet);
  } else {
    if (needsImport && importFileNames) {
      var _importString = createImportStatementString({
        fileNames: importFileNames,
        extension: valueType,
        includeAs: needsImport && valueType === 'scss'
      });
      var _colorVariablesString = stringWithoutColorMode(colorSet, needsRoot);
      return _importString + "\n      " + _colorVariablesString + "\n      ";
    }
    return stringWithoutColorMode(colorSet, needsRoot);
  }
  function stringWithColorMode(colorSet) {
    var outputString = "\n" + WARNING_TEXT + "\n[data-color-mode='light'],\n:root {\n  " + colorSet.filter(function (color) {
      return (color == null ? void 0 : color.mode) === 'light';
    }).map(function (color) {
      var colorKey = color[keyType].key;
      var colorValue = keyType === 'css' && valueType === 'scss' ? color[valueType].sanitizedValue : color[valueType].value;
      return colorKey + ": " + colorValue + ";";
    }).join('\n  ') + "\n}\n\n[data-color-mode='dark'] {\n  " + colorSet.filter(function (color) {
      return (color == null ? void 0 : color.mode) === 'dark';
    }).map(function (color) {
      var colorKey = color[keyType].key;
      var colorValue = keyType === 'css' && valueType === 'scss' ? color[valueType].sanitizedValue : color[valueType].value;
      return colorKey + ": " + colorValue + ";";
    }).join('\n  ') + "\n}\n";
    return outputString;
  }
  function stringWithoutColorMode(colorSet, needsRoot) {
    var outputString = "\n" + WARNING_TEXT + "\n" + (needsRoot ? ':root {' : '') + "\n" + (needsRoot ? '\t' : '') + colorSet.map(function (color) {
      var colorKey = color[keyType].key;
      var colorValue = keyType === 'css' && valueType === 'scss' ? color[valueType].sanitizedValue : color[valueType].value;
      return colorKey + ": " + colorValue + ";";
    }).join("\n" + (needsRoot ? '\t' : '')) + "\n" + (needsRoot ? '}' : '') + "\n  ";
    return outputString;
  }
  function createImportStatementString(_ref2) {
    var fileNames = _ref2.fileNames,
      extension = _ref2.extension,
      includeAs = _ref2.includeAs;
    var IMPORT_SYNTAX = {
      css: '@import',
      scss: '@use',
      less: '@import'
    };
    var asStatement = includeAs ? ' as *' : '';
    var importStatements = fileNames.map(function (fileName) {
      var importPath = "'@entur/tokens/dist/" + fileName + "." + extension + "'";
      return "" + (extension === 'scss' ? '@forward ' + importPath + ';\n' : '') + IMPORT_SYNTAX[extension] + " " + importPath + asStatement + ";";
    });
    return importStatements.join('\n');
  }
}
function createColorsFileData(_ref3) {
  var colorSet = _ref3.colorSet,
    keyType = _ref3.keyType,
    valueType = _ref3.valueType,
    name = _ref3.name,
    outputToPackages = _ref3.outputToPackages,
    _ref3$withColorMode = _ref3.withColorMode,
    withColorMode = _ref3$withColorMode === void 0 ? false : _ref3$withColorMode,
    importFileNames = _ref3.importFileNames;
  var outputString = '';
  if (outputToPackages) {
    var outputData = [];
    outputToPackages.forEach(function (packageName) {
      outputString = '';
      var variablesForCurrentPackage = colorSet.filter(function (variable) {
        return variable.scss.key.includes("-" + packageName + "-");
      });
      if (variablesForCurrentPackage.length === 0) {
        return;
      }
      if (packageName === 'travel') {
        outputString += createColorsOutputString({
          colorSet: variablesForCurrentPackage,
          keyType: keyType,
          valueType: valueType,
          withColorMode: true,
          importFileNames: ['semantic', 'transport']
        });
      } else {
        outputString += createColorsOutputString({
          colorSet: variablesForCurrentPackage,
          keyType: keyType,
          valueType: valueType,
          withColorMode: true,
          importFileNames: ['semantic']
        });
      }
      outputData.push({
        outputString: outputString,
        outputFileName: name + ".scss",
        packageName: packageName
      });
    });
    return outputData;
  }
  switch (name) {
    case 'base':
      outputString += createColorsOutputString({
        colorSet: colorSet,
        keyType: keyType,
        valueType: valueType,
        withColorMode: true,
        importFileNames: ['semantic', 'transport']
      });
      break;
    case 'semantic':
      outputString += createColorsOutputString({
        colorSet: colorSet,
        keyType: keyType,
        valueType: valueType,
        withColorMode: false,
        importFileNames: ['primitive']
      });
      break;
    case 'data':
      outputString += createColorsOutputString({
        colorSet: colorSet,
        keyType: keyType,
        valueType: valueType,
        withColorMode: true
      });
      break;
    default:
      outputString += createColorsOutputString({
        colorSet: colorSet,
        keyType: keyType,
        valueType: valueType,
        withColorMode: withColorMode,
        importFileNames: importFileNames
      });
  }
  return [{
    outputString: outputString,
    outputFileName: name + "." + valueType
  }];
}
function createJSColorFileData(_ref4) {
  var variables = _ref4.variables,
    name = _ref4.name;
  var jsVariables = variables.map(function (color) {
    var _ref5;
    return _ref5 = {}, _ref5[color == null ? void 0 : color.js.key] = color == null ? void 0 : color.js.value, _ref5;
  });
  var jsVariablesObject = Object.assign.apply(Object, [{}].concat(jsVariables));
  var unflattenedJSVariablesObject = unflatten(jsVariablesObject);
  var outputString = WARNING_TEXT + "\n export const " + name + " = " + JSON.stringify(unflattenedJSVariablesObject) + "\n ";
  return {
    outputString: outputString,
    outputFileName: name + ".ts"
  };
}
function toKebabCase(name) {
  return name.replace(/\//g, '-').replace(/\s/g, '').toLowerCase();
}
function toFlattenedJSObjectKey(name) {
  var nameWithoutSpacesAndDashes = name.toLowerCase().replace(/\s(\w)/g, function (_, letter) {
    return letter.toUpperCase();
  }).replace(/\-(\w)/g, function (_, letter) {
    return letter.toUpperCase();
  });
  var nameArray = nameWithoutSpacesAndDashes.split('/');
  var nameArrayWithStringNumbers = nameArray.map(function (namePart) {
    if (!isNaN(Number(namePart.charAt(0)))) {
      return "_" + namePart;
    }
    return namePart;
  });
  return nameArrayWithStringNumbers.join('.');
}

export { base, borderRadiuses, borderWidths, breakpoints, colors, componentColors, createColorSet, createColorsFileData, createJSColorFileData, data, fontSizes, fontWeights, lineHeights, outlineOffsets, outlines, primitive, semantic, shadows, space, timings, transport, zIndexes };
//# sourceMappingURL=tokens.esm.js.map
